{
    "ariaLabel": {
        "viewDetails": "詳細を表示",
        "downloadDataAssets": "データアセットをダウンロード"
    },
    "topMenu": {
        "dihTitle": "データインテリジェンスハブ",
        "DIHOrgRegistration": "データインテリジェンスハブ - 組織登録",
        "dihSubTitle": "データから安全に価値を抽出する",
        "logout": "ログアウト",
        "myAccount": "マイアカウント",
        "myOrganization": "自分の組織"
    },
    "userLogoutAlert": {
        "title": "本当にログアウトしますか？",
        "back": "戻る",
        "logout": "ログアウト",
        "myOrganization": "自分の組織"
    },
    "sideMenu": {
        "dashboard": "ダッシュボード",
        "connectors": "コネクタ",
        "myConnectors": "自分のコネクタ",
        "dataspaces": "データスペース",
        "discover": "発見する",
        "manage": "管理",
        "marketplace": "マーケットプレイス",
        "myDataspaces": "自分のメンバーシップ",
        "browseDataspaces": "データスペースを閲覧",
        "organizations": "組織",
        "build": "構築",
        "ownedDataspaces": "自分のデータスペース",
        "collapse": "サイドバーを折りたたむ",
        "participate": "参加する",
        "getVerified": "認証を受ける",
        "workbench": "ワークベンチ",
        "dataIncoming": "受信データ",
        "applications": "アプリケーション",
        "verify": "検証",
        "digitalIDDashboard": "インサイトを取得",
        "mySignatures": "自分の署名",
        "externalConnectionManager": "外部接続マネージャー"
    },
    "dropdown": {
        "selectAll": "すべて選択",
        "noOption": "利用可能なオプションがありません",
        "noSuchOption": "そのようなオプションは存在しません…"
    },
    "common": {
        "start": "開始",
        "finish": "完了",
        "firstName": "名",
        "lastName": "姓",
        "email": "メールアドレス",
        "phoneNumber": "電話番号",
        "contactPerson": "連絡先担当者",
        "welcome": "ようこそ",
        "street": "通り",
        "city": "市区町村",
        "region": "地域",
        "country": "国",
        "postCode": "郵便番号",
        "number": "番号",
        "next": "次へ",
        "prev": "戻る",
        "alreadyAccount": "すでにアカウントをお持ちですか？",
        "login": "ログイン",
        "loginNow": "今すぐログイン",
        "register": "登録",
        "home": "ホーム",
        "submit": "送信",
        "attention": "注意",
        "desc": "説明",
        "website": "ウェブサイト",
        "contact": "連絡先",
        "details": "詳細",
        "plan": "計画",
        "listView": "リスト表示",
        "gridView": "グリッド表示",
        "firstPage": "最初のページへ",
        "previousPage": "前のページへ",
        "nextPage": "次のページへ",
        "lastPage": "最後のページへ",
        "download": "ダウンロード",
        "delete": "削除",
        "edit": "編集",
        "information": "情報",
        "organization": "組織",
        "cancel": "キャンセル",
        "save": "保存",
        "upload": "アップロード",
        "link": "リンク",
        "view": "表示",
        "search": "検索",
        "searchTerm": "検索",
        "selectOption": "オプションを選択",
        "sortBy": "並び替え",
        "dataspace": "データスペース",
        "select": "選択",
        "date": "日付",
        "title": "タイトル",
        "successful": "成功",
        "unsuccessful": "失敗",
        "statuses": {
          "connected": "接続済み",
          "disconnected": "切断済み",
          "deploying": "デプロイ中",
          "deployed": "デプロイ済み",
          "failed": "失敗",
          "available": "利用可能",
          "success": "成功",
          "active": "アクティブ",
          "pending": "保留中",
          "declined": "却下",
          "invited": "招待済み",
          "onboarding": "オンボーディング中",
          "withdrawn": "取り下げ済み",
          "successful": "成功",
          "unsuccessful": "失敗",
          "valid": "有効",
          "expired": "期限切れ",
          "revoked": "無効",
          "inprogress": "進行中",
          "rejected": "拒否",
          "inactive": "不活発な",
          "subscribed": "登録済み"
        },
        "andMore": "他 {count} 件",
        "confirm": "確認",
        "yes": "はい",
        "no": "いいえ",
        "links": {
        "dihWiki": "https://docs.dih.telekom.com/en/home"
        },
        "formError": "何か問題があります。",
        "question": {
        "interested": "興味ありますか？"
        },
        "moreInfo": "詳細情報が必要な場合：",
        "goToWebsite": "当社ウェブサイトへ",
        "provider": "提供者",
        "required": "必須",
        "errors": "エラー",
        "error": "エラー",
        "from": "開始日",
        "to": "終了日",
        "openLinkInNewTab": "新しいタブでリンクを開く",
        "formatError": "形式が無効です。入力内容を確認して、もう一度お試しください。",
        "ID": "ID"
    },
    "genericError": "問題が発生しました。もう一度お試しください。",
    "validation": {
        "fieldRequired": "{field} は必須です。",
        "fieldNumeric": "{field} フィールドは数字のみを含めることができます。",
        "fieldAlpha": "{field} フィールドは文字、_、- のみを含めることができます。",
        "fieldAlphanumeric": "{field} フィールドは英数字、_、- のみを含めることができます。",
        "fieldNumericDash": "{field} フィールドは数字と - のみを含めることができます。",
        "fieldHouseNumber": "{field} フィールドは数字、文字、および - と / を含めることができます。",
        "fieldPhoneNumber": "{field} フィールドは数字と - のみ。+ または 00 で始まる必要があります。",
        "fieldAlphaDash": "{field} フィールドは文字と - のみを含めることができます。",
        "exceptHTMLTagBrackets": "{field} フィールドには ^<> を含めないでください。",
        "alphaNumericExtended": "{field} フィールドには、文字、数字、-, /, # および . のみ使用できます",
        "ipOrCidrRegex": "値は有効な IP アドレスである必要があります",
        "isMaxLength": "最大文字数（10文字）を超えています。",
        "emailFormat": "メールアドレスの形式が正しくありません",
        "fileSizeError": "ファイルサイズが {size} MB を超えています。",
        "csvFileSizeError": "このファイルは大きすぎます。{size} MB までアップロード可能です。",
        "csvFileExtensionError": "CSV拡張子のファイルのみアップロードできます。",
        "csvFileIsEmptyError": "このファイルは空です。少なくとも {size} KB のファイルをアップロードしてください。",
        "csvFileFormatError": "ファイル形式が正しくありません。提供されたテンプレートを使用して再試行してください。",
        "uploadFails": "アップロードに失敗しました",
        "fileExtensionError": "ファイルの拡張子が不適切です",
        "fileIsMalwareInfectedError": "このファイルにはマルウェアが含まれている可能性があります。セキュリティ上の理由からアップロードできません。再確認してください。",
        "customValidation": "{field} の形式が正しくありません。",
        "selectCountryFirst": "先に国名を選択してください",
        "validationPostCodeCaseDE": "形式が正しくありません。5桁の数字でなければなりません（例：53113）",
        "validationAlphanumericCase": "英数字、ハイフン、アンダースコアのみ使用可能。英数字で始まる必要があります。",
        "validationNumericDashCase": "数字と - のみ使用可能です。",
        "url": "有効なURLを入力してください",
        "maxInvitationSize": "一度に招待できるのは最大 {size} 人までです",
        "errorUploadingFile": "ファイルのアップロード中にエラーが発生しました。再試行してください。",
        "password": {
        "passwordStrength": "パスワードの強度",
        "weak": "弱い",
        "average": "普通",
        "strong": "強い",
        "passwordValidationMoreChar": "{count} 文字以上",
        "passwordUpperAndLowerChar": "大文字と小文字の両方を含む",
        "passwordAtLeastNumber": "数字を1つ以上含む",
        "passwordAtLeastSpecialChar": "特殊文字を1つ以上含む（<>&\"`[]を除く）",
        "passwordDiffFromPrev": "以前のパスワードと異なる必要があります"
        },
        "orgName": "{field} フィールドは文字、数字、_、-、& のみ使用可能です。",
        "tagLimitMessage": "{count} 個までのユースケースしか追加できません。"
    },
    "footer": {
        "tagLine": "より高いパフォーマンスを実現しましょう",
        "imprint": "インプリント",
        "imprintShort": "インプリント",
        "imprintLink": "https://dih.telekom.com/en/imprint",
        "contact": "お問い合わせ",
        "contactLink": "https://dih.telekom.com/en/contact",
        "termsAndConditions": "利用規約",
        "privacy": "プライバシーポリシー",
        "privacyShort": "プライバシー",
        "telekom": "T-Systems International GmbH. 無断転載を禁じます。",
        "telekomShort": "T-Systems International GmbH",
        "note": "Telekom Data Intelligence Hub - 法人専用",
        "brandedNote": "Telekom Data Intelligence Hub 提供",
        "help": "ヘルプ",
        "cookieSettings": "クッキー設定",
        "cookieSettingsShort": "クッキー",
        "life": "人生は共有するためにある"
    },
    "onboarding": {
      "welcome": "Data Intelligence Hubへようこそ",
      "welcomeDIH": "Data Intelligence Hubへようこそ",
      "thankYouEnterprise": "Connect & Integrate Enterpriseをお選びいただきありがとうございます",
      "informationForOrganization": "あなたの組織情報",
      "orgNameLabel": "組織名",
      "orgUnitNameLabel": "組織単位名",
      "emailAddressLabel": "メールアドレス",
      "countryNameLabel": "国",
      "bpnNumberLabel": "ビジネスパートナー番号(BPN)",
      "contactPersonInfo": "連絡先",
      "fillInfoBelow": "以下の情報をご記入ください",
      "orgRegNameLabel": "組織/ユニットの登録名",
      "legalNameHint": "組織の正式名称を入力してください",
      "addressHeading": "組織本部の住所",
      "PLZCode": "郵便番号",
      "verifyEmail": "メールを確認する",
      "verifyEmailMessage": "Data Intelligence Hubにご参加いただきありがとうございます。あなたの組織はすでに登録されています。メールアドレスを確認してください。",
      "taxId": "VAT番号",
      "commerceRegisterNumber": "商業登記番号",
      "orgRepresentative": {
        "title": "組織の代表者のアカウントを設定します",
        "orgContactPerson": "組織の連絡先",
        "whatDefinesYou": "あなたを最もよく定義するものは何ですか?",
        "agreeText": "私はData Intelligence Hubの{1}を読み、遵守することを確認します",
        "confirmText": "私は、私の個人データが<a href='#'>データプライバシーステートメント」に従って保存および処理されることに同意します。</a>"
      },
      "success": "組織の登録に成功しました",
      "underReview": "あなたの組織は検証されています。",
      "verified": "組織の確認に成功しました",
      "month": "月 |月|{count} ヶ月",
      "steps": {
        "counter": {
          "step": "ステップ",
          "of": "の"
        },
        "stepWizard": {
          "orgInfo": "組織情報",
          "selectConnection": "接続を選択してください",
          "configureConnection": "接続を構成します",
          "selectPackage": "プランを選択してください",
          "checkout": "チェックアウト",
          "enterpriseTitle": "折り返しご連絡いたします",
          "enterpriseSubtitle": "それまでの間、もう少し詳しく教えてください。そうすれば、よりよいお手伝いができるようになります。"
        },
        "actionButton": {
          "back": "戻る",
          "next": "次へ",
          "order": "支払い義務のある注文",
          "checkout": "チェックアウト",
          "selectMyPlan": "マイプランを選択してください",
          "submitRequest": "リクエストを送信",
          "editModeDisabled": "既存の注文には変更が加えられていません。"
        },
        "orgStep": {
          "fields": {
            "orgInfoLabel": "組織の詳細",
            "dataSpaceAttributes": "追加の属性",
            "orgName": "組織の正式名称",
            "departmentName": "部署名",
            "crnNumber": "商業登記番号",
            "taxId": "VAT番号",
            "bpnNo": "ビジネスパートナー番号(BPN)",
            "addressInfo": "請求先住所",
            "countryName": "国",
            "plzCode": "郵便番号",
            "number": "番号",
            "city": "都市",
            "street": "通り",
            "contactPersonLabel": "連絡先",
            "fullName": "フルネーム",
            "firstName": "名",
            "firstNamePlaceholder": "名を入力してください",
            "lastName": "姓",
            "lastNamePlaceholder": "姓を入力してください",
            "contactPerson": "連絡先",
            "phoneNo": "電話番号",
            "emailAdd": "メールアドレス",
            "dataPrivacyCheck": "私は、私の個人データが{dataprivacystatement}および{supplementaryDataPrivacyConditions}に従って保存および処理されることに同意します。",
            "dataPrivacyCheckNew": "私は、個人データが{dataprivacystatement}に従って保存および処理されることに同意します。",
            "termsAndConditionsCheck": "私は、会社の正式な代表者として、{termsandcondition}を読み、理解し、同意したことを確認します。",
            "dataprivacystatement": "データプライバシーに関する声明",
            "supplementaryDataPrivacyConditions": "補足データプライバシー条件",
            "termsandcondition": "利用規約",
            "agreeToEnterContract": "私は{serviceDescription}に基づいてT-Systems International GmbHと契約を結ぶことに同意します",
            "serviceDescription": "サービスの説明",
            "markettingConsentCheck": "私は、T-Systems International GmbHおよびTelekom Deutschland GmbHから製品、サービス、イベントに関するマーケティングメール、手紙、電話、またはSMS / MMSを受け取ることに同意します。この同意は、{email} にメールを送信することで、いつでも取り消すことができます。"
          }
        },
        "connection": {
          "sectionHeading": "接続を選択してください",
          "sectionSubHeading": "{dsName}の接続タイプを選択してください",
          "textNote": "Catena-Xと互換性のあるオプションのみ選択可能",
          "recommendedConfiguration": "推奨構成",
          "cloudProvider": "クラウドプロバイダー",
          "cloudProviderTooltip": "このサブスクリプションで推奨されるクラウドプロバイダー",
          "contactSales": "営業担当に連絡"
        },
        "packages": {
          "sectionHeading": "プランを選択してください",
          "sectionSubHeading": "データプランのバリエーション",
          "basedOnYourSelection": "お客様の選択に基づいて、以下を推奨します",
          "dataPackage": "データパッケージ",
          "outgoingTraffic": "発信トラフィック",
          "storage": "ストレージ",
          "selectedDataPlan": "データプランを選択",
          "dataPlanDetails": "データプランの詳細",
          "dataPlanLabelForVolume": "ボリュームが含まれているプラン",
          "dataPlanLabelFlexible": "従量課金制",
          "packageAvailable": "このパッケージはこのプランでのみ利用可能です",
          "chargesApply": "使用量が音量制限を超えた場合、料金が適用されます",
          "additionalStorage": "追加のストレージ",
          "additionalTraffic": "追加の送信トラフィック",
          "oneTimeSetUpCharges": "1回限りの設定料金",
          "starterKit": "スターターキット",
          "starterKitTooltip": "技術的なアクセス設定、アカウントの作成、機能テスト、ナレッジベースの統合など、環境を簡単にセットアップできます。詳細については、チェックアウト時に提供されるサービスの説明を参照してください。",
          "onboardingKit": "オンボーディングキット",
          "onboardingKitTooltip": "データスペースソリューションの実装に合わせたサポートを提供するように設計された、柔軟な時間単位のコンサルティングパッケージ。当社の専門専門家チームによって提供されます。詳細については、チェックアウト時に提供されるサービスの説明を参照してください。",
          "pleaseSelectYourDesiredContractDuration": "ご希望の契約期間を選択してください",
          "subscriptionTitle": "接続の表示名",
          "subscriptionTitleLabel": "接続の表示名を入力してください",
          "automatedIntegrationCapabilities": "自動統合機能",
          "automatedIntegrationCapabilitiesTooltip": "自動統合機能 は、データスペースとの半自動統合を実現するための追加機能を提供します。これには、データマッピング、ローコードデータ変換などが含まれます。",
          "boschDtrTitle": "ボッシュの高性能デジタルツインレジストリをお探しですか?",
          "optional": "オプション",
          "boschDtrDescription": "ボッシュは、数百万のデジタルツインを迅速に識別および取得し、作成、割り当て、保存、削除を容易にするデジタルディレクトリであるDigital Twin Registry(DTR)を提供しています。下のチェックボックスをクリックしてください。当社の営業チームが喜んでお手伝いいたします。」",
          "boschDtrLearnMore": "もっと詳しく知る",
          "boschDtrContactSaleCheck": "T-Systems International GmbHの営業チームから連絡を希望します"
        },
        "zoneSelection": {
          "zoneSelectionTitle":"データはどこに置きたいですか?",
          "zoneSelectionTooltip":"データを保管したいエリアを選択してください。"
        },
        "cloudProviders": {
          "cloudInfrastructure": "選択したゾーン内のどのクラウドプロバイダーですか?",
          "toolipContent": "あなたのニーズに最も適したクラウドプロバイダーをお選びください。",
          "cloudAvailable": "このパッケージは、このクラウド プロバイダーでのみ利用可能です"
        },
        "checkout": {
          "sectionHeading": "{orgName}への接続パッケージ",
          "setupCost": "セットアップ費用",
          "monthlyCost": "月額費用",
          "payg": "従量課金制",
          "pipSheet": "製品情報シート",
          "totalCost": "総コスト",
          "totalPayable": "合計支払額",
          "dataPrivacyCheck": "上記で注文したサービスに関連する料金を支払うことに同意します",
          "termsAndConditionsCheck": "契約期間とキャンセルポリシーに同意します",
          "termsandcondition": "利用規約",
          "EOMAmountPolicy": "私は、支払われる合計金額が月末に計算されることを受け入れます。",
          "generalAgreement": "「上記のサービス内容に基づいてT-Systems International GmbHと契約を締結することに同意します」",
          "DPAAgreement": "私は'データ処理契約'(DPA)に同意します",
          "dataprocessingagreement": "データ処理契約",
          "dataPackage": "データパッケージ",
          "dataPlan": "データプラン",
          "outgoingTraffic": "含まれる発信トラフィック",
          "storagePrice": "ストレージ価格",
          "perGigabyteForStorage": "ストレージ用/ GB",
          "perGigabyteForOutgoingTraffic": "送信トラフィックの場合は/ GB",
          "outgoingTrafficPrice": "発信トラフィック価格",
          "contractDuration": "契約期間",
          "contractDurationIconTooltip": "要件に基づいて契約の期間を選択してください",
          "contractDurationTooltip": "このサブスクリプションの推奨契約期間",
          "defaultContractDuration": "6ヶ月",
          "price": "価格",
          "perGigabyte": "GBあたり",
          "monthlyCancelable": "毎月キャンセル可能",
          "storage": "含まれるストレージ",
          "linksText": {
            "information": "情報シート",
            "service": "サービスの説明"
          },
          "plusCharges": "{plus}はあなたの消費に対して料金を請求します",
          "plus": "プラス",
          "basedOnConsumption": "消費量に基づく",
          "selectedConfiguration": "選択した構成",
          "oneTimeCosts": "1回限りのコスト",
          "connectionType": "接続タイプ",
          "dataIntegrationLevel": "データ統合レベル",
          "addOns": "アドオン",
          "connectors": "コネクタ",
          "totalUseCases": "合計ユースケース数：",
          "totalAmount": "合計金額",
          "supplementaryDataPrivacyConditionsCheck": "私は、私の個人データが{supplementaryDataPrivacyConditions}に従って保存および処理されることに同意します",
          "supplementaryDataPrivacyConditions": "補足データプライバシー条件",
          "withIncludedVolume": "含まれるボリューム付き",
          "cloudProvider": "クラウドプロバイダー",
          "selectedZone": "地域",
          "additionalCharges": "*月間ボリュームを超えた場合は料金が適用されます",
          "semiAutomatedApiCapability": "API機能付き半自動化",
          "manualApiCapability": "API機能付きマニュアル"
        },
        "useCases": {
          "title": "ユースケースを選択してください",
          "tagText": "追加のユースケースごとに月額100ユーロの費用がかかります。",
          "bodyText": "Catena-Xの参加に使用するユースケースを選択してください。少なくとも 1 つを選択する必要があります。最初のユースケースは、サブスクリプションにデフォルトで含まれています。好きなだけ選択でき、最初のユースケースに加えて選択した追加のユースケースごとに100ユーロの料金が適用されます。」"
        },
        "cancelModal": {
          "confirmQuestion": "選択した接続をキャンセルしてもよろしいですか?",
          "confirmYes": "はい、キャンセルします",
          "confirmNo": "いいえ、続行"
        },
        "enterprisePackage": {
          "inputTitle": "メッセージ",
          "inputPlaceholder": "入力を開始",
          "emptyErrorMessage": "メッセージは空にすることも、スペースのみにすることもできません",
          "validCharErrorMessage": "メッセージに無効な文字が含まれています",
          "noURLsErrorMessage": "メッセージにリンクやURLを含めることはできません",
          "limitRepeatsErrorMessage": "メッセージに過剰な繰り返し文字が含まれています"
        }
      },
      "statuses": {
        "complete": {
          "title": "すでに登録されています",
          "description": "登録リンクは再度使用できません。",
          "buttonText": "ホームへ戻る"
        },
        "error": {
          "title": "問題が発生しました",
          "description": "プロセスを再起動してください",
          "buttonText": "再起動"
        },
        "expired": {
          "title": "申し訳ございませんが、リンクの有効期限が切れています",
          "description": "Catena-Xポータルからプロセスを再起動してください。",
          "buttonText": "カテナ-Xに戻る"
        },
        "success": {
          "title": "ご登録いただきありがとうございます",
          "description": "私たちはあなたの組織の詳細を確認しています。詳細については、メールでお知らせします。",
          "buttonText": "当社のウェブサイトに移動"
        },
        "invalid": {
          "title": "無許可",
          "description": "このページにアクセスする権限がありません。",
          "buttonText": "当社のウェブサイトに移動"
        },
        "dih-success": {
          "title": "ご登録いただきありがとうございます",
          "description": "私たちはあなたの組織の詳細を確認しています。詳細については、メールでお知らせします。",
          "buttonText": "当社のウェブサイトに移動"
        },
        "orgNotFound": {
          "title": "あなたの組織が見つかりませんでした",
          "descriptionLine1": "ごめんなさい!あなたの組織がまだオンボーディングされていないか、T-Systemsサービスのサブスクリプションをリクエストしていないようです。",
          "descriptionLine2": "T-Systems認定のCatena-X向けイネーブルメントサービスのサブスクリプションを{marketplace}からお申し込みください。",
          "marketplace": "marketplace",
          "descriptionLine3": "これが間違いだと思うなら、{contactOurSalesTeam}をお願いします。喜んでサポートいたします。",
          "contactOurSalesTeam": "営業チームにお問い合わせください",
          "exploreTheKnowledgeBase": "ナレッジベースを探索する",
          "readOurBlog": "ブログを読む"
        },
        "ds-success": {
          "title": "ご注文ありがとうございます",
          "description": "私たちはあなたの組織の詳細を正常に受け取りました。",
          "descriptionPara2": "詳細を確認中です。折り返し、メールにてご連絡いたします。",
          "buttonText": "始めましょう"
        }
      },
      "orgExistLogin": {
        "title": "Data Intelligence Hubのアカウントをすでにお持ちですか?",
        "action": "ログイン",
        "error": {
          "permissionErrorTitle": "このページにアクセスするために必要な権限がありません。",
          "permissionErrorText": "詳細については、組織の管理者にお問い合わせください",
          "orgNotFoundTitle": "組織が見つかりません",
          "orgNotFoundText": "お客様のメールアドレスから組織を特定することはできません。登録フォームに必要事項を記入し、注文の詳細を提供してください。"
        }
      },
      "newOnboarding": {
        "address": {
          "country": "国*",
          "region": "地域*",
          "street": "通り*",
          "number": "番号*",
          "postCode": "郵便番号*",
          "city": "市区町村*",
          "organisationAddress": "組織の住所",
          "organisationAddressSubheading": "組織の住所を入力してください",
          "billingAddress": "請求先住所",
          "billingAddressSubheading": "請求先住所を入力してください",
          "sameAsOrgAddress": "請求先住所は組織の住所と同じです。"
        },
        "organisationInformation": "組織情報",
        "organisationInformationSubheading": "組織情報を入力してください",
        "organisationName": "組織の正式名称",
        "organisationNameInfo": "組織の法的に有効な名称を入力してください",
        "transliteratedName": "ローマ字表記 (ラテン文字)",
        "transliteratedNameInfo": "任意: レビュー担当者のためにローマ字で名前を入力してください。これは公式の名前である必要はありません。",
        "transliteratedNamePrompt": "法的氏名が非ラテン文字で入力されています。審査担当者のためにラテン文字での転写をご検討ください。",
        "transliteratedNameValidationMsg": "レビュアーの確認を助けるため、ラテン文字での転写を入力してください。",
        "contactDetailsHeading": "連絡先情報",
        "contactDetailsSubheading": "連絡先情報を入力してください",
        "firstName": "名*",
        "lastName": "姓*",
        "emailAddress": "メールアドレス*",
        "phoneNumber": "電話番号*",
        "companyIdentifierHeading": "組織識別子",
        "companyIdentifierSubheading": "続行するには、次の一意の ID の少なくとも 1 つを入力してください*",
        "identifierType": "識別子タイプ*",
        "identifierValue": "識別子値*",
        "identifierTypeError": "識別子タイプを選択してください",
        "identifierValueError": "識別子値が必要です",
        "identifierValueFormatError": "無効な形式です。例: {field}"
      }
    },
    "dashboard": {
      "pageTitle": "ホーム",
      "pageSubtitle": "これは、Data Intelligence Hub内のすべてのコントロールセンターです。"
    },
    "services": {
      "finishConfig": "設定を完了",
      "open": "開く",
      "viewDetails": "詳細を表示",
      "configure": {
        "uploadCertification": "データスペースの運用者から受け取った証明書をアップロードしてください。",
        "dragAndDropCertificate": "ここに証明書ファイルをドラッグ&ドロップしてください。",
        "didntReceive": "受け取っていない、または入手方法がわからない?こちらの手順に従ってください」",
        "uploadSuccessMessage": "証明書は正常にアップロードされました"
      },
      "table": {
        "attribute": "属性",
        "value": "値",
        "apiKey": "APIキー",
        "apiKeyValue": "APIキー値",
        "controlPlaneUrl": "コントロールプレーンURL",
        "idsURL": "DSP API エンドポイント",
        "connectorUrl": "コネクタURL",
        "dataManagementUrl": "データ管理APIエンドポイント",
        "dataDashboard": "データダッシュボード",
        "participantDid": "参加者DID ID"
      }
    },
    "dataspaces": {
      "dataspaces": "データスペース",
      "viewAllDataspaces": "すべてのデータスペースを表示",
      "managedConnectorsHeading": "管理されたコネクター",
      "externalConnectorsHeading": "外部コネクター",
      "connectorTestDescription": "接続が期待どおりに実行され、データスペースへの接続がアクティブであるかどうかをテストするためのアプリケーションです。",
      "configure": {
        "pageTitle": "データスペース接続の設定",
        "basicInfo": "基本情報",
        "certificate": "証明書",
        "instructionCertrificate": "データスペースオペレータから受け取った証明書をアップロードしてください。"
      },
      "connectorHealthCheck": {
        "title": "コネクタのヘルスチェック",
        "copiedToClipboard": "クリップボードにコピーしました",
        "description": "このアプリケーションの助けを借りて、選択したコネクタが設定され、期待どおりに動作しているかどうかを確認するためのセルフテストが実行されます。これにより、選択したコネクタの設定やストレージは変更されません。",
        "connectorid": "コネクタID",
        "model": {
          "title": "コネクタのヘルスチェックが進行中です...",
          "body": "健康診断の進行中は退出できません。退出を希望される場合は、健康診断を終了し、再度行う必要があります。",
          "toLeave": "いいえ、去りたいです",
          "toFinish": "ヘルスチェックを完了する"
        },
        "banner": {
          "initiate": "ヘルスチェックの実行には数分かかる場合があります。結果が利用可能になり次第、通知されます。",
          "success": "あなたのConnectセルフテストは成功しました!過去のテストの結果を表示するには、上の[結果]をクリックしてください。",
          "failed": "ごめんなさい!Connectのセルフテストに失敗しました。{email}までご連絡ください。喜んでサポートいたします。」",
          "email": "dih.support{'@'}telekom.com"
        },
        "buttonState": {
          "initiate": "開始する",
          "success": "オープンコネクト",
          "failed": "サポートに連絡する",
          "back": "戻る"
        }
      },
      "browse": {
        "browseDataspace": "データスペースの参照",
        "availableDS": "利用可能なデータスペース",
        "howToConnect": "接続方法",
        "getConnected": "接続する",
        "requestConnection": "接続のリクエスト",
        "viewRequest": "表示リクエスト",
        "viewDetails": "詳細を表示",
        "highlightNote": "{selectedDataspaceName}でメンバーシップを管理したい場合は、サポートにお問い合わせください：",
        "uncoverByInvitation": "招待によって発見する",
        "dataspaceDetails": "データスペースの詳細",
        "participantOverview": "参加者の概要",
        "services": "サービス",
        "networking": "ネットワーキング",
        "networkingDesc": "このデータ空間は、許可されるIPアドレスの範囲によってネットワークのサービスや接続へのアクセスを制限する場合があります。アプリケーションに問題が発生した場合は、現在のIPアドレスや範囲をホワイトリストに載せるために、データスペースの管理者に連絡してください。",
        "networkingIPTitle": "私のIPアドレス(ブラウザ)",
        "networkingInfoText": "もしアプリケーションが別のデバイスで動いているなら、そのデバイスにログインして、例えば」のようなコマンドを出すことができます。",
        "networkingCurlCommand": "“curl --location 'ifconfig.me/ip”",
        "networkingHighlightNote": "ご質問があればサポートまでお問い合わせください:",
        "joinRequestSuccessTitle": "{dataspaceName}への参加リクエストが送信されました",
        "joinRequestSuccessBody": "リクエストが処理されると、さらに情報が得られます",
        "dataspaceMembershipId": "Dataspace メンバーシップID",
        "uncover": {
          "title": "招待によってデータスペースを表示する",
          "subtitle": "どのデータスペースをお探しですか?",
          "fieldLabels": "データスペース演算子によって提供される詳細を入力してください",
          "sendRequest": "リクエストを送信",
          "back": "戻る",
          "dataspaceId": "データスペースID",
          "password": "パスワード"
        },
        "requestDetailsModal": {
          "withdraw": "引き出し",
          "cancel": "キャンセル",
          "update": "更新",
          "withdrawConfirmationHeading": "データスペース参加リクエストを撤回",
          "withdrawConfirmationBody": "データスペース{dataspaceName}への参加リクエストを取り下げるつもりであることを再確認してください。",
          "notification": {
            "withdrawSuccessfulTitle": "データスペース参加リクエストが取り下げられました",
            "withdrawSuccessfulBody": "{dataspaceName}への参加リクエストは取り下げられました。",
            "updateSuccessfulTitle": "データスペース結合要求が更新されました",
            "updateSuccessfulBody": "{dataspaceName} への参加リクエストが更新されました。"
          }
        }
      },
      "user": {
        "myMemberships": "マイメンバーシップ",
        "enterDS": "データスペースに入る",
        "registeredDS": "あなたのデータスペース",
        "noMembership": {
          "title": "まだメンバーシップがありません",
          "description": "データスペースを参照して1つを結合する",
          "actionButtonText": "接続してください"
        }
      },
      "statuses": {
        "attentionRequired": "要注意",
        "comingSoon": "近日公開",
        "connected": "接続済み",
        "disconnected": "切断",
        "deploying": "デプロイ中",
        "deployed": "デプロイ済み",
        "failed": "失敗",
        "available": "利用可能",
        "success": "成功"
      }
    },
    "verify": {
      "orgProfile": "組織プロフィール",
      "legalName": "正式名称",
      "address": "住所",
      "contact": "連絡先",
      "vatID": "VAT番号",
      "requestChange": "変更をリクエストする",
      "downloadVCMessage": "VCが正常にダウンロードされました",
      "placeholderEnterSelectInput": "リストから値を入力または選択",
      "vcOverview": {
        "masterHeading": "資格情報の種類",
        "credentialTypeCards": {
          "description": {
            "legalPerson": "これは、登録の詳細、ビジネスID、組織の法的地位などの法人情報のデジタル表現です。",
            "serviceOffering": "これは、プロバイダーがコンシューマに提供するためのパッケージに結合するアセットとリソースのコレクションです。",
            "physicalResource": "これは、測定可能な重量と空間的な位置を持つリソースであり、ホスト、マニピュレーター、または他の物理的エンティティとの相互作用の参加者として機能する有形のエンティティを表します。",
            "softwareResource": "これは、ソースコードなどの非物理的な機能を含むアセットの一種です",
            "dataResource": "これは、任意の形式のデータ(派生データも含む)で構成され、データ共有に必要な情報を含む資産の一種です。"
          },
          "cta": {
            "enter": "入力"
          }
        },
        "credentialOverview": "資格情報の概要",
        "credentialErrorMessage": "{type}資格情報の取得中にエラーが発生しました",
        "searchByNamePlaceholder": "名前で検索",
        "credentialErrorDetailsMessage": "現在、資格情報の取得に技術的な問題に直面しています。しばらくしてからもう一度お試しください"
      },
      "verifiableCredentials": {
        "getVerified": "確認済み",
        "credentials": "資格情報",
        "requestCredential": "資格情報のリクエスト",
        "whichTypeToSelect": "どのタイプを選択すべきですか?",
        "noCredentialsMessage": "まだ{type}の資格情報がありません",
        "credentialInfoMessage": "認証情報を追加すると、エコシステムの参加者間の信頼レベルが上がります。",
        "credentialModalMessage": "お客様の資格情報は、企業のアイデンティティ、専門知識、または正当性を確立する資格または情報の一部です。",
        "learnMore": "もっと詳しく知る",
        "status": {
          "all": "すべて",
          "valid": "有効",
          "expired": "期限切れ",
          "revoked": "取り消された"
        },
        "types": {
          "legalPerson": "会社の識別情報",
          "serviceOffering": "コンプライアンスと認証",
          "physicalResource": "物理リソース",
          "dataResource": "データリソース",
          "softwareResource": "ソフトウェアリソース",
          "membership": "メンバーシップ"
        },
        "form": {
          "type": {
            "placeholder": "資格情報の種類を選択してください",
            "label": "資格情報の種類",
            "error": "資格情報の種類が必要です"
          },
          "types": {
            "legalPerson": "法人",
            "serviceOffering": "サービス提供",
            "resource": "リソース",
            "physicalResource": "物理リソース",
            "dataResource": "データリソース",
            "softwareResource": "ソフトウェアリソース"
          },
          "companyInformationSectionTitle": "会社情報",
          "companyInformationSectionSubtitle": "会社情報を入力してください",
          "legalName": {
            "label": "組織の正式名称",
            "helpText": "法的拘束力のある組織の名前を使用してください"
          },
          "country": {
            "placeholder": "国を選択",
            "label": "国",
            "error": "国が必要です"
          },
          "region": {
            "placeholder": "地域を選択",
            "label": "地域",
            "error": "地域が必要です"
          },
          "street": {
            "label": "番地と番地"
          },
          "city": {
            "label": "市区町村"
          },
          "postalCode": {
            "label": "郵便番号"
          },
          "commercialIdentificationSectionTitle": "商業識別",
          "commercialIdentificationSectionSubtitle": "続行するには、次の一意のIDを少なくとも1つ入力してください*",
          "CRN": {
            "label": "商業登記番号",
            "helpText": "例: HRB 55933",
            "tooltipText": "商業登記番号(CRN)は、合法的な商業登録のために企業に割り当てられる一意の識別子です。これは、信頼できるデータソースに対する企業の登録および金融取引識別子の信頼性を検証および検証するために使用されます。」"
          },
          "vatId": {
            "label": "VAT番号",
            "helpText": "例: DE 118 645 675",
            "tooltipText": "VAT番号(付加価値税識別番号)は、税務目的でビジネスに割り当てられた一意の識別子です。"
          },
          "eori": {
            "label": "EORI",
            "helpText": "例: DE 103 280 493 572",
            "tooltipText": "EORI(Economic Operator's Registration and Identification number)は、欧州連合(EU)内で国際貿易に従事する経済事業者に割り当てられた一意の識別子です。"
          },
          "lei": {
            "label": "LEI",
            "helpText": "例: 5299009D9BIL4D4UHT93",
            "tooltipText": "LEI(取引主体識別子)は、世界の金融市場に関与する金融取引に関与する取引主体に割り当てられた一意の識別コードです。"
          },
          "didSectionTitle": "分散型識別子(DID)",
          "didSubSectionTitle": "DIDがない場合は、このフィールドを空にしてください。自動的に生成されます。",
          "did": {
            "label": "資格情報の件名 (DID)",
            "helpText": "did:example123456789abcd",
            "tooltipText": "DIDは、DIDドキュメントに解決できる一意の識別子です。DIDは、分散型デジタルIDの基本的な構成要素です。」"
          },
          "certificate": {
            "error": "証明書が必要です"
          },
          "request": "リクエスト",
          "requesting": "リクエストしています...",
          "certificateSectionHeading": "署名",
          "certificateSectionTitle": "署名にはどの証明書を使用しますか?",
          "addCertificate": "新しい証明書を追加",
          "chooseCertificate": "証明書を選択してください",
          "tsystemsCertificate": "T-Systemsの証明書",
          "yourCertificate": "あなたの証明書",
          "consentTooltip": "このオプションを選択すると、T-Systemsがお客様に代わって上記の文書に署名することを許可したことになります。詳細については、ドキュメントを確認してください。",
          "consentPersonalData": "私は、上記の私のすべての個人情報とデータ(以下「個人データ」)が正確であることに同意し、確認します。",
          "consentProcessing": "私はここに、Gaia-Xが私のデータ（個人の機密データを含む）を処理することに同意し、承認します。"
        },
        "vcRequestSuccess": "リクエストは正常に送信されました",
        "selectAllButton": "すべて選択",
        "deselectAllButton": "すべて選択解除",
        "revokeButton": "取り消す",
        "searchboxPlaceholder": "少なくとも3文字を入力してください",
        "credentialTile": {
          "issuedBy": "発行者",
          "issuedOn": "発行日",
          "expiresOn": "有効期限",
          "expiredOn": "有効期限が切れました",
          "viewDetailsButton": "詳細を表示"
        },
        "revokeModal": {
          "heading": "確認を取り消す",
          "question": "アイテムを取り消してもよろしいですか?",
          "note": "ノート:",
          "message": "資格情報を取り消すと、その資格情報は無効になり、使用できなくなります。有効な資格情報を取得するには、新しい資格情報をリクエストする必要があります。",
          "primaryButton": "取り消し",
          "secondaryButton": "キャンセル"
        },
        "deleteCredential": {
          "heading": "削除確認",
          "question": "資格情報を削除してもよろしいですか?",
          "deleteSuccess": "資格情報は正常に削除されました"
        },
        "credentialsDetailsModal": {
          "heading": "資格情報の詳細",
          "selfDescriptionCredential": "自己記述の資格情報",
          "type": "タイプ",
          "id": "id",
          "issuer": "issuer",
          "issuanceDate": "issuanceDate",
          "expirationDate": "expirationDate",
          "credentialSubject": "credentialSubject",
          "bpn": "ctxsd:bpn",
          "participantName": "gx-participant:name",
          "participantNameLegalName": "gx-participant:legalName",
          "legalRegistrationNumber": "gx:participant:legalRegistrationNumber",
          "EUID": "gx:EUID",
          "leiCode": "gx:leiCode",
          "vatID": "gx:vatID",
          "registrationNumberType": "gx:registrationNumberType",
          "registrationNumberNumber": "gx:registrationNumberNumber",
          "headquarterAddress": "gx:participant:headquarterAddress",
          "addressCountryCode": "gx:addressCountryCode",
          "countrySubdivisionCode": "gx:countrySubdivisionCode",
          "locality": "gx:locality",
          "streetAddress": "gx:streetAddress",
          "legalAddress": "gx:participant:legalAddress",
          "termsAndConditions": "gx-participant:termsAndConditions",
          "serviceOfferingName": "gx:serviceOfferingName",
          "serviceOfferingDescription": "gx:serviceOfferingDescription",
          "providedBy": "gx:providedBy",
          "aggregationOf": "gx:aggregationOf",
          "aggregationOfId": "gx:id",
          "policy": "gx:policy",
          "serviceOfferingTermsAndConditions": "gx:termsAndConditions",
          "url": "gx:URL",
          "hash": "gx:hash",
          "dataAccountExport": "gx:dataAccountExport",
          "requestType": "gx:requestType",
          "accessType": "gx:accessType",
          "formatType": "gx:formatType",
          "proof": "証明",
          "created": "created",
          "proofPurpose": "proofPurpose",
          "verificationMethod": "verificationMethod",
          "jws": "jws",
          "status": "ステータス",
          "primaryButton": "ダウンロード",
          "secondaryButton": "キャンセル",
          "resourceName": "gx:name",
          "resourceDescription": "gx:description",
          "resourceCopyrightOwnedBy": "gx:copyrightOwnedBy",
          "resourceExposedThrough": "gx:exposedThrough",
          "resourceProducedBy": "gx:producedBy",
          "resourcePolicy": "gx:policy",
          "resourceLicense": "gx:license",
          "resourceContainsPII": "gx:containsPII",
          "resourceMaintainedBy": "gx:maintainedBy",
          "resourceOwnedBy": "gx:ownedBy",
          "resourceManufacturedBy": "gx:manufacturedBy",
          "resourceCountryCode": "国コード",
          "resourceLocality": "ローカリティ",
          "resourcePostalCode": "郵便番号",
          "resourceStreetAddress": "住所",
          "legalPersonRegistrationNumber": "gx:lagelRegistrationNumber"
        },
        "notificationText": "申し訳ございませんが、検索条件に一致する結果が見つかりませんでした。検索を絞り込んで、もう一度お試しください。",
        "bulkUpload": {
          "title": "パートナーを検証",
          "helpText": "提供されたテンプレートに記入して、ビジネスパートナーを一度に検証します",
          "uploadFileTitle": "ファイルをアップロード",
          "requestCredentials": "資格情報のリクエスト",
          "uploadFormHelpHeading": "複数の会社を検証するには、以下の操作を行ってください：。",
          "uploadFormHelpText1": "以下のリンクからテンプレートファイルをダウンロードしてください",
          "uploadFormHelpText2": "提供されたファイルにビジネスパートナーの詳細を記入してください",
          "uploadFormHelpText3": "下のアップロードエリアにファイルをドロップしてください",
          "downloadTemplateBtn": "テンプレートをダウンロード",
          "partnerValidationHelpText": "パートナーの検証についてもっと詳しく知りたい場合は、お願いします",
          "partnerValidationHelpLink": "ここをクリック",
          "uploadFile": {
            "uploadFileHeading": "アップロードするCSVファイルを選択してください"
          },
          "vcProcessingTitle": "レコードの処理",
          "bulkVcContinueBtn": "続行",
          "issuingProgressMessage": "資格情報の発行が進行中です...",
          "doNotCloseWarning": "処理が終了するまでフォームを閉じないでください",
          "bulkVcDownloadReportBtn": "レポートのダウンロード",
          "successMessage": "正常に完了しました!",
          "failedErrorMessage": "{result}エントリのエラー",
          "processAbortTitle": "処理中",
          "processAbortDescription": "処理を停止してもよろしいですか?",
          "stopProcessingBtn": "処理を停止"
        },
        "validation": {
          "vatId": {
            "field": "有効なVAT番号を入力してください。",
            "AT": "ヒント: 'ATU' で始まり、その後に 8 桁が続く必要があります。",
            "BE": "ヒント: 'BE' で始まり、その後に 10 桁の数字が続く必要があります。",
            "BG": "ヒント: 'BG' で始まり、その後に 9 桁または 10 桁が続く必要があります。",
            "CY": "ヒント: 'CY' で始まり、その後に 8 桁の数字と 1 文字が続く必要があります。",
            "CZ": "ヒント: 'CZ' で始まり、その後に 8 桁から 10 桁が続く必要があります。",
            "DE": "ヒント: 'DE' で始まり、その後に 9 桁が続く必要があります。",
            "DK": "ヒント: 'DK' で始まり、その後に 8 桁が続く必要があります。",
            "EE": "ヒント: 'EE' で始まり、その後に 9 桁の数字が続く必要があります。",
            "EL": "ヒント: 'EL' で始まり、その後に 9 桁が続く必要があります。",
            "ES": "ヒント: 'ES' で始まり、その後に文字と数字を混在させる必要があります。",
            "FI": "ヒント: 'FI' で始まり、その後に 8 桁が続く必要があります。",
            "FR": "ヒント: 'FR' で始まり、その後に 2 文字と 9 桁の数字が続く必要があります。",
            "HR": "ヒント: 'HR' で始まり、その後に 11 桁の数字が続く必要があります。",
            "HU": "ヒント: 'HU' で始まり、その後に 8 桁が続く必要があります。",
            "IE": "ヒント: 'IE' で始まり、その後に数字と文字の複雑な組み合わせが続く必要があります。",
            "IT": "ヒント: 'IT' で始まり、その後に 11 桁の数字が続く必要があります。",
            "LT": "ヒント: 'LT' で始まり、その後に 9 から 12 桁が続く必要があります。",
            "LU": "ヒント: 'LU' で始まり、その後に 8 桁が続く必要があります。",
            "LV": "ヒント: 'LV' で始まり、その後に 11 桁が続く必要があります。",
            "MT": "ヒント: 'MT' で始まり、その後に 8 桁が続く必要があります。",
            "NL": "ヒント: 'NL' で始まり、その後に 9 桁と 'B' + 2 桁が続く必要があります。",
            "PL": "ヒント: 'PL' で始まり、その後に 10 桁の数字が続く必要があります。",
            "PT": "ヒント: 'PT' で始まり、その後に 9 桁が続く必要があります。",
            "RO": "ヒント: 'RO' で始まり、その後に 2 桁から 10 桁が続く必要があります。",
            "SE": "ヒント: 'SE' で始まり、その後に 12 桁の数字が続く必要があります。",
            "SI": "ヒント: 'SI' で始まり、その後に 8 桁が続く必要があります。",
            "SK": "ヒント: 'SK' で始まり、その後に 10 桁の数字が続く必要があります。",
            "XI": "ヒント: 'XI' で始まり、その後に 9 桁が続く必要があります。"
          },
          "eori": "有効なEORIを入力してください。ヒント:2つの大文字で始まり、その後に9〜15桁の数字が続く必要があります。",
          "lei": "有効なLEIを入力してください。ヒント: 20 文字で、最初の 18 文字は大文字の英数字で、最後の 2 桁は大文字である必要があります。",
          "did": "有効なDIDを入力してください。'did:' で始まり、その後にメソッドとセグメントをコロンで区切り、文字、数字、'%'、'.'、'_'、'-' のみを使用する必要があります。",
          "hash": "有効なSHA-256ハッシュを入力してください。正確に 64 文字の 16 進数文字 (0 から 9、A から F) である必要があります。",
          "format_type": "有効な形式タイプを入力してください。単語の後に '/' が続き、有効な文字列 (文字、数字、'-'、'+'、'.'、または '_') である必要があります。"
        }
      },
      "serviceOfferingForm": {
        "generalInformationHeading": "一般情報",
        "labelSOName": "サービス提供名",
        "labelProvidedBy": "提供元",
        "labelSODescription": "サービス提供の説明",
        "hintSOName": "サービス提供物の人間が読める名前",
        "hintProvidedBy": "サービスを提供する参加者の自己記述へのDID形式の解決可能なリンク",
        "hintSODescription": "DSLを使用して表現されたポリシーのリスト（RegoやODRL、アクセス制御、スロットル、使用、保持など)",
        "resourcesHeading": "リソース",
        "labelSOResources": "リソースの自己記述",
        "hintSOResources": "リソース自己記述のDID形式の解決可能なリンクで、サービスに関連し、それとは独立して存在できる",
        "termsAndConditionsHeading": "利用規約",
        "labelUrlSO": "URL",
        "labelHashSO": "ハッシュ",
        "termsAndConditionsTooltip": "サービス提供に適用される利用規約への解決可能なリンク",
        "labelSOPolicy": "ポリシー",
        "policyTooltip": "サービス提供に適用されるポリシーへの解決可能なリンク",
        "personalDEHeading": "個人データのエクスポート",
        "personalDETooltip": "サービスのお客様が個人データと非個人データをサービス外にエクスポートできるようにします。",
        "labelRequestTypeSO": "リクエストタイプ",
        "labelAccessTypeSO": "アクセスタイプ",
        "placeholderRequestTypeSO": "リクエストタイプを選択",
        "placeholderAccessTypeSO": "アクセスタイプを選択",
        "labelFormatTypeSO": "フォーマットタイプ",
        "hintRequestTypeSO": "データ取得をリクエストする方法: API, メール, ウェブフォーム, unregisteredLetter, registeredLetter, supportCenter",
        "hintAccessTypeSO": "サポートするデータのタイプ: デジタル、物理",
        "hintFormatTypeSO": "で定義されているメディアタイプ（MIMEタイプ）",
        "consentTC1": "私はここに同意し、上記のすべての入力データが正確であることを確認します。",
        "consentTC2": "私は、T-Systemsが私のデータ(個人の機密データを含む)を処理することに同意し、許可します。",
        "consentTC3": "私はここに同意します",
        "gaiaXTermsText": "Gaia-Xの利用規約",
        "requestTypesList": {
          "api": "API",
          "email": "メール",
          "webform": "ウェブフォーム",
          "unregisteredLetter": "未登録の手紙",
          "registeredLetter": "書留郵便",
          "supportCenter": "サポートセンター"
        },
        "requestTypesError": "リクエストタイプが必要です。",
        "accessTypesList": {
          "digital": "デジタル",
          "physical": "フィジカル"
        },
        "accessTypesError": "アクセスタイプが必要です。",
        "helpSOName": "人間が読めるサービスの名前を入力してください",
        "helpProvidedBy": "サービスを提供する参加者の分散型識別子",
        "helpSOResources": "このサービスを通じて公開されるリソースの分散型識別子",
        "helpUrlSO": "T&Cドキュメント(例:https://service.com/terms)へのリンクを入力してください",
        "helpHashSO": "T&Cドキュメントのsha256ハッシュを入力してください",
        "helpPolicySO": "DSL (Rego や ODRL など) を使用して表現されたポリシーを入力してください",
        "helpRequestTypeSO": "ドロップダウンリストからリクエストタイプを選択してください",
        "helpAccessTypeSO": "ドロップダウンリストからアクセスタイプを選択してください",
        "helpFormatTypeSO": "MIMEタイプを入力してください（例:application/json)"
      },
      "resourceForm": {
        "generalInformationHeading": "一般情報",
        "generalInformationSubHeading": "リソースの一般情報を入力してください",
        "labelResourceType": "リソースの種類",
        "placeholderResourceType": "リソースタイプを選択してください",
        "errorResourceType": "リソースタイプが必要です",
        "labelResourceName": "リソース名",
        "labelResourceDescription": "リソースの説明",
        "hintResourceType": "記述されているリソースのタイプ",
        "hintResourceName": "人間が読めるリソースの名前",
        "hintResourceDescription": "人間が読めるリソースの説明",
        "physicalResource": "物理リソース",
        "softwareResource": "ソフトウェアリソース",
        "dataResource": "データリソース",
        "additionalInformationHeading": "追加情報",
        "additionalInformationSubHeading": "リソースの追加情報を入力してください",
        "labelMaintainedBy": "保守担当者",
        "hintMaintainedBy": "リソースが動作可能な状態で維持され、物理的にアクセスできる参加者のGaia-X資格情報への解決可能なリンク",
        "labelOwnedBy": "所有者",
        "hintOwnedBy": "リソースを所有する参加者のGaia-X資格情報への解決可能なリンク",
        "labelManufacturedBy": "製造元",
        "hintManufacturedBy": "リソースを製造している参加者のGaia-X資格情報への解決可能なリンク",
        "labelCountry": "国",
        "hintCountry": "リソースが配置されている国",
        "labelCity": "市区町村",
        "hintCity": "リソースが配置されている都市/町",
        "labelPostCode": "郵便番号",
        "hintPostCode": "リソースが配置されている郵便番号",
        "labelStreet": "通り",
        "hintStreet": "リソースが配置されている番地と番",
        "labelCopyrightOwnerBy": "著作権所有者",
        "hintCopyrightOwnerBy": "著作権所有者とは、リソースを利用する権利を持つ個人または組織です。著作権所有者は、必ずしもリソースの著者を指すわけではなく、自然人であり、著作権所有者とは異なる場合があります。フリーテキストとして、または著作権所有者のGaia-Xクレデンシャルへの解決可能なリンクとして表現されています。",
        "labelLicense": "ライセンス",
        "hintLicense": "ライセンス文書のURLまたはライセンスの1つ",
        "labelPolicy": "ポリシー",
        "hintPolicy": "DSL(例:RegoやODRL)を使用して表現されたポリシーのリスト（アクセス制御、スロットル、使用、保持など）。ポリシー制約が省略された場合、その使用はすべての参加者に許可されていると見なされます。",
        "labelProducedBy": "プロデュース",
        "hintProducedBy": "データの使用を合法的に可能にする参加者のGaia-X資格情報への解決可能なリンク。",
        "labelExposedThrough": "露出スルー",
        "hintExposedThrough": "データリソースを公開したデータ交換コンポーネントへの解決可能なリンク",
        "locationHeading": "位置情報の詳細",
        "locationSubHeading": "リソースの場所の詳細を入力してください",
        "licenseTooltipText": "SPDXライセンスリスト",
        "licenseTooltipLink": "https://spdx.org/licenses/",
        "consentPII": "私は、データリソースに個人を特定できる情報(PII)が含まれていないことをここに確認します。"
      },
      "verifyLanding": {
        "heading": "確認を受ける'へようこそ'",
        "subHeading": "デジタルエコシステムの信頼性を高めましょう!",
        "description1": "ビジネスパートナーの確認と検証をしたいのか、それとも自分自身のIDと検証を表示したいですか?次に、最初の検証可能な資格情報をリクエストする必要があります-私たちの」。",
        "description2": "検証可能な資格情報には、物理的な識別情報(IDカード、運転免許証など)と同じ情報と、さらに多くの属性を含めることができます。デジタル署名などのテクノロジーが加わることで、検証可能な資格情報は、物理的なものよりも改ざんが明確で信頼性が高くなります。",
        "description3": "T-Systemsは、最初のGaia-Xデジタルクリアリングハウスノードの一つとして運営されており、Gaia-X Trust Frameworkの仕様に従ってあなたのデジタル証明を発行します。さらに、Telekom SecurityパートナーからのeIDAS準拠のデジタル署名を追加します。",
        "requestButton": "リクエスト Digital.ID",
        "digitalID": "Digital.ID 製品です。",
        "consultation": {
          "heading": "資格情報を要求するか、パートナーを検証してください",
          "placeholder": "検証可能な資格情報に関する過去の経験はありますか? 初めての資格に興味がありますか?"
        },
        "sendAnotherRequest": "別のリクエストを送信",
        "lastRequest": "最新のリクエストが送信されました"
      },
      "getInsights": {
        "tab1": "レポート",
        "tab2": "APIの使用制限",
        "tab3": "技術統合",
        "monthsByOptions": {
          "option1": "3ヶ月",
          "option2": "6ヶ月",
          "option3": "1ヶ月"
        },
        "table": {
          "heading2": "参照期間",
          "heading3": "作成日時",
          "heading4": "アクション"
        },
        "successDownload": "レポートのダウンロードに成功しました",
        "errorDownload": "{filename}のファイルのダウンロードがエラーで中止されました。もう一度やり直してください。",
        "apiUsageLimit": {
          "requestNameTitle": "リクエスト名",
          "dailyTitle": "毎日のAPIリクエスト",
          "monthlyTitle": "毎月のAPIリクエスト",
          "limitexhaustedWarning": "残りのリクエストの10%未満",
          "limitExtentionHeading": "リクエスト制限の延長",
          "limitExtentionPlaceholder": "APIの使用制限の延長に興味がありますか?",
          "supportBtn": "サポート",
          "limitExtentionText": "もうすぐ限界に達しますか?私たちと連絡を取って、解決しましょう!」"
        },
        "addIntegration": "統合を追加",
        "integrationData": {
          "clientId": "クライアントID",
          "createdAt": "作成日時",
          "actions": "アクション"
        }
      },
      "addIntegration": {
        "generalInformationHeading": "一般情報",
        "addAnIntegration": "統合を追加",
        "clientId": "クライアントID",
        "clientName": "クライアント名",
        "clientSecret": "クライアントシークレット",
        "tokenUrl": "トークンURL",
        "pcCallbackUrl": "参加者の資格情報コールバックURL",
        "soCallbackUrl": "サービス提供資格情報のコールバックURL",
        "digitalIdAuthenticateInfo1": "Digital.ID 検証は、あなたのシステムに対してどのように認証されますか?",
        "digitalIdAuthenticateInfo2": "Digital.ID Complianceは、お客様のシステムに対してどのように認証されますか?",
        "seeResults": "結果はどこに送ればいいの？",
        "requestSuccess": "追加に成功しました",
        "callbackSuccess": "コールバックが正常に追加されました",
        "step1Name": "認証内容",
        "step2Name": "コンプライアンス認証の詳細",
        "step3Name": "コールバック情報",
        "deleteSuccess": "正常に削除されました",
        "downloadSuccess": "正常にダウンロードされました",
        "editCallbackHeading": "コールバックを追加",
        "deleteModal": {
          "heading": "削除確認",
          "deleteContent": "クライアントを削除してもよろしいですか?",
          "deleteNote": "クライアントを削除すると、そのクライアントはリストから消えて使用できなくなります。復元するには、最初から作り直す必要があります」"
        }
      },
      "mySignatures": {
        "certificatesOrdering": {
          "heading": "My signatures'へようこそ'",
          "subHeading": "請求に署名できるデジタル証明書をリクエストしますか?",
          "description1": "当社の Digital.ID 製品を使用すると、最初の証明書を簡単にリクエストして、安全なデジタルコラボレーションのメリットを享受し始めることができます。",
          "description2": "検証可能な資格情報には、IDカードや運転免許証など、物理的な識別子と同じ情報を含めることができます。発行プロセスでは、信頼できる証明書で署名することにより、情報の正確性を確認します。",
          "description3": "すべての署名ニーズに対して、デジタル証明書を安全にリクエストし、維持することができます。当社は、認定されたデジタル証明書プロバイダーと独占的に提携し、お客様のデジタル証明書が安全で信頼できるものであることを保証しています。",
          "requestButton": "証明書のリクエスト",
          "consultation": {
            "heading": "証明書のリクエスト",
            "placeholder": "リクエストについて必要な詳細を入力してください"
          }
        },
        "certificateOverview": {
          "heading": "私の署名",
          "requestCertificateCTA": "証明書のリクエスト",
          "placeholderCertificateType": "証明書の種類",
          "placeholderCertificateStatus": "証明書のステータス",
          "EVSSL": "EV SSL",
          "EIDAS": "EIDAS",
          "headingEVSSL": "EV SSL 証明書",
          "headingEIDAS": "EIDAS証明書",
          "certificateDetailsHeading": "証明書の詳細",
          "certificateName": "名前",
          "certificateId": "ID",
          "certificateType": "タイプ",
          "provider": "プロバイダー",
          "organizationId": "組織ID",
          "UUID": "UUID",
          "certificate": "証明書",
          "createdAt": "作成日",
          "updatedAt": "更新日",
          "certificateExpiry": "有効期限",
          "certificateVerificationMethod": "検証方法",
          "certificateDidJson": "DID JSON",
          "status": "ステータス",
          "certificateDownloadSuccess": "証明書が正常にダウンロードされました",
          "deleteCertificate": {
            "heading": "削除確認",
            "question": "証明書を削除してもよろしいですか?",
            "deleteSuccess": "証明書は正常に削除されました"
          }
        }
      }
    },
    "build": {
      "ownedDataspaces": "マイデータスペース",
      "checkConsent": "私は、私の連絡先データがT-Systemsの営業チームに提供され、連絡を受けることに同意します。",
      "welcomeOwnedDataspace": "'所有データスペース'へようこそ",
      "resendInvitation": "再送",
      "resendInvitationInfo": "最後の招待メールから24時間が経過するとすぐに通知を送信できます。",
      "requestSuccessTitle": "リクエストが成功しました!",
      "requestSuccessBody": "リクエストが送信されました...数日後に回答が届きます",
      "requestAuthorisation": "必要な権限を増やしたい場合は、dih.support{'@'}telekom.com までご連絡ください。",
      "inviteParticipant": {
        "buttonLabel": "参加者を招待",
        "successNotificationTitle": "招待に成功しました!",
        "successNotificationContent": "招待が正常に送信されました",
        "alreadySentNotificationTitle": "このメールアドレスにはすでに招待状が送信されています。",
        "alreadySentNotificationContent": "招待を再度送信する前に、24時間お待ちください。",
        "resendInviteNotificationTitle": "再招待に成功しました!",
        "resendInviteNotificationContent": "再招待が正常に送信されました",
        "modal": {
          "title": "参加者を招待",
          "informationTitle": "情報",
          "informationText": "招待された組織は、他の参加者とデータを交換し、データスペースで新しいデータアセットを公開できます。さらに、組織は、データスペースの一部であるアプリケーションとサービスを使用できます。詳細については、以下をご覧ください。",
          "formTitle": "新しい参加者の詳細を入力してください",
          "organizationName": "組織名",
          "proceed": "進行する",
          "cancel": "キャンセル"
        },
        "withdrawInvitation": {
          "modal": {
            "title": "招待を取り下げる",
            "informationText": "招待を撤回してもよろしいですか?",
            "successNotificationTitle": "引き出しに成功しました",
            "successNotificationBody": "招待は正常に取り下げられました",
            "withdraw": "出金"
          }
        },
        "resendInvitation": {
          "modal": {
            "title": "招待状を再送信",
            "informationText": "この招待状を再送信してもよろしいですか?"
          }
        }
      },
      "editParticipant": {
        "modal": {
          "title": "参加者を編集",
          "cancel": "キャンセル",
          "save": "保存",
          "roleSection": {
            "name": "役割",
            "helpText": "どの役割を選択すべきですか?",
            "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
            "ownerLabel": "データスペースの所有者",
            "ownerTooltip": "参加者とアプリケーションを管理できるデータスペースの所有者",
            "operatorLabel": "データスペース演算子",
            "operatorTooltip": "オペレーターツールキットとオンボードアプリケーションを管理できる参加者",
            "operatorCheckboxTooltip": "あなたはデータスペースの所有者です。したがって、演算子の選択を解除することはできません。",
            "appProviderLabel": "アプリケーションプロバイダ",
            "appProviderTooltip": "アプリケーションをデータスペースにオンボードできるデータスペース参加者",
            "participantLabel": "データスペース参加者",
            "participantTooltip": "データ提供者およびデータ利用者として行動できる参加者",
            "participantCheckboxTooltip": "データスペースの参加者は無効にできません。これがデータスペース内のユーザーのデフォルトのステータスです。"
          },
          "visibilitySection": {
            "name": "可視性",
            "helpText": "どの可視性を選択すべきですか?",
            "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
            "anonymousLabel": "匿名",
            "anonymousLabelTitle": "匿名の参加者",
            "anonymousTooltip": "他の参加者から隠れていて、他の参加者を見ることができない参加者"
          }
        },
        "updateSuccessfulTitle": "アップデートに成功しました!",
        "updateSuccessfulBody": "新しい役割と可視性が採用されました"
      },
      "applicationManagement": {
        "buttonLabel": "アプリケーションの登録",
        "registerForm": {
          "pageTitle": "アプリケーション登録",
          "step1Name": "アプリケーションの詳細",
          "step2Name": "アプリケーションアクセス",
          "displayName": "表示名",
          "providedBy": "プロバイダー",
          "providedByPlaceholder": "組織名",
          "description": "説明",
          "descriptionPlaceholder": "説明テキスト",
          "link": "リンク",
          "linkPlaceholder": "https://www.application-link-example.org/",
          "appImage": "アプリケーション画像(JPGまたはPNG.2 MB に制限)」、*",
          "appImagePlaceholder": "ここにファイルをドラッグ&ドロップするか、クリックしてファイルを選択してください",
          "appImagePlaceholder2": "または、コンピュータ上のファイルを参照します",
          "category": "カテゴリ",
          "categoryPlaceholder": "カテゴリを入力",
          "usecases": "ユースケース",
          "usecasesPlaceholder": "ユースケースを入力",
          "agreementCheckboxLabel": "私はここに、私が登録しているアプリケーションに対して全責任を負い、それがいかなる種類のマルウェアでもないことに同意します。また、ライセンス違反がないことを確認しています。私は、アプリケーションのアクセス管理について全責任を負うこと、およびT-Systems International GmbHがこの点に関して一切の責任を負わないことを理解しています。T-System International GmbHは、アプリケーションおよびそれなりに起こりうる結果について、いかなる方法でも責任を負いません。"
        },
        "deleteApplication": {
          "modal": {
            "title": "アプリケーションの削除",
            "informationText1": "このアプリケーションリンクをデータスペースから削除したいかどうか、再度確認してください。このアプリケーションは、データスペース内のどの参加者も利用できません。",
            "informationText2": "実際のアプリケーションは影響を受けないことに注意してください!",
            "successNotificationTitle": "削除に成功しました",
            "successNotificationBody": "アプリケーションが正常に削除されました",
            "cancel": "キャンセル",
            "delete": "削除"
          }
        },
        "editForm": {
          "pageTitle": "アプリケーションの編集",
          "step1Name": "アプリケーションの詳細",
          "step2Name": "アプリケーションアクセス",
          "displayName": "表示名",
          "providedBy": "プロバイダー",
          "providedByPlaceholder": "組織名",
          "description": "説明",
          "descriptionPlaceholder": "説明テキスト",
          "link": "リンク",
          "successNotificationTitle": "編集に成功しました",
          "successNotificationBody": "アプリケーションが正常に編集されました",
          "linkPlaceholder": "https://www.application-link-example.org/",
          "currentImage": "現在の画像",
          "agreementCheckboxLabel": "私はここに、私が登録しているアプリケーションに対して全責任を負い、それがいかなる種類のマルウェアでもないことに同意します。また、ライセンス違反がないことを確認しています。私は、アプリケーションのアクセス管理について全責任を負うこと、およびT-Systems International GmbHがこの点に関して一切の責任を負わないことを理解しています。T-System International GmbHは、アプリケーションおよびそれなりに起こりうる結果について、いかなる責任も負いません。",
          "cancel": "キャンセル",
          "save": "変更を保存"
        }
      },
      "networkManagement": {
        "buttonLabel": "新しい IP アドレスを追加",
        "pageTitle": "ネットワーク管理",
        "ipAddressLabel": "IP アドレス",
        "lastUpdatedOn": "最終更新日",
        "ipHint": "IPアドレス更新のリクエストを受信しました。まもなく処理されます。",
        "ipRemove": "このIPアドレスを削除してもよろしいですか？",
        "ipRequired": "IPアドレスが必要です",
        "ipInvalid": "有効なIPアドレスを入力してください",
        "ipEnter": "データスペースにアクセスするためにホワイトリストに追加するIPアドレスを入力してください。"
      },
      "invite": {
        "inviteLabel": "参加者を招待する"
      },
      "allocateConnectors": {
        "pageTitle": "コネクタの割り当て",
        "allocateConnectorLabel": "コネクタを割り当てる",
        "topUpConnectorsButtonLabel": "トップアップコネクタ",
        "topUpConnectorTitle": "リクエストが正常に送信されました。",
        "topUpConnectorBody": "当社のサポートチームができるだけ早くご連絡し、詳細について話し合います。",
        "generalTooltipMessage": "DIHサポート（dih.support{'@'}telekom.com）に連絡して、既存の参加者に新しいコネクタを割り当てるか、新しい参加者をデータスペースに招待してください。",
        "tooltipMessage": "契約に従って利用可能なコネクタの最大数はすでに使い果たしています。クォータの増額や契約の変更をご希望の場合は、dih.support{'@'}までご連絡ください telekom.com",
        "allocationForm": {
          "step1Name": "組織",
          "step2Name": "コネクタ",
          "organizationNameDescription": "新しいコネクタを割り当てる会社を選択してください",
          "organizationNameLabel": "組織名",
          "organizationPlaceholder": "組織を選択",
          "inviteParticipantDescription": "または、データスペース上で新しい会社を招待するために、参加者を招待するボタンをクリックしてください。",
          "inviteParticipantButton": "参加者を招待",
          "numberOfConnectorsDescription": "接続数を選択してください",
          "numberOfConnectorsLabel": "コネクタの数",
          "numberOfConnectorsPlaceholder": "カウント",
          "progressBarDescription": "コネクタのクォータ",
          "progressBarInfo": "{numberOfConnectors} コネクタが利用可能",
          "allocateButtonLabel": "割り当てる",
          "cancelButtonLabel": "キャンセル",
          "noConnectorRemaining": "すべてのコネクタが使用されます。「コネクタの追加」をクリックして、コネクタの拡張について当社のチームと話し合ってください。"
        },
        "successRequestTest": "リクエスト成功",
        "successRequestBody": "コネクタの割り当てが正常に開始されました",
        "decisionModal": {
          "title": "{dataspaceName}に参加するように招待されました",
          "accept": "受け入れる",
          "decline": "衰退",
          "acceptSuccessNotificationTitle": "受け入れに成功しました!",
          "acceptSuccessNotificationBody": "{dataspaceName}への参加招待を無事に承諾しました。",
          "declineSuccessNotificationTitle": "招待が拒否されました!",
          "declineSuccessNotificationBody": "{dataspaceName}への参加招待を拒否しました。"
        }
      },
      "request": {
        "requestTitle": "データ共有の旅の次のステップに進み、自分だけのデータスペースを作りましょう!",
        "requestDescription1": "自分のデータを共有するだけでなく、ビジネスパートナー同士がデータを共有できるようにしたいのですか?次に、データの共有や収益化のための信頼できるコミュニティであるデータスペースの作成を検討する必要があります。",
        "requestDescription2": "T-Systemsは、信頼性の高いインフラストラクチャ上にお客様のデータスペースをセットアップし、運用します。",
        "requestDescription3": "初めてのデータスペース体験('LivingLab')のための低閾値テストセットアップも提供しています。",
        "request": "リクエスト",
        "sendAnotherRequest": "別のリクエストを送信",
        "lastRequest": "前回のリクエストが送信されました",
        "back": "戻る",
        "sendRequest": "リクエストを送信",
        "requestedTextPlaceholder": "何か特定の相談や一般的な相談をお探しですか?データスペースに関する以前の経験はありますか?テストセットアップに興味がありますか?",
        "visitorAnalyticsPro": {
          "title": "モーションデータによるビジターアナリティクスPROのリクエスト",
          "placeholder": "データニーズに合った特定の製品や一般的なコンサルティングをお探しですか?Motion Data製品を使用した経験はありますか?デモンストレーションに興味がありますか?"
        }
      },
      "create": {
        "createTitle": "自分だけのデータスペースを作成",
        "createDesc": "私たちの専門家チームにリクエストを送信していただければ、折り返しご連絡いたします。",
        "tellUsMore": "ご要望について詳しく教えていただけますか?"
      },
      "details": {
        "approve": "承認",
        "decline": "衰退",
        "approval": "承認",
        "requesterNotes": "リクエスターノート",
        "adminNotes": "管理者ノート",
        "decisionTakenTooltip": "承認または拒否は既に発生しています。コネクタの提供については、現在準備中です。これらが完了するとすぐにお知らせします。",
        "decisionInputPlaceholder": "承認または拒否のメモ...",
        "activeParticipants": "アクティブな参加者",
        "incomingRequests": "受信リクエスト",
        "invitations": "招待状",
        "manage": "manage",
        "enter": "入力",
        "providedBy": "プロバイダー",
        "registered": "登録済み",
        "operatorToolkit": "オペレーターツールキット",
        "noOperatorToolkit": "オペレーター ツールキットで有効なツールがありません。",
        "errorOperatorToolkit": "オペレーター ツールキットの詳細の取得エラー",
        "dataspaceDetails": "データスペースの詳細",
        "contactDetails": "連絡先の詳細",
        "visibilityTitle": "ブラウズデータスペースリストからデータスペースを非表示にします",
        "manageParticipants": "参加者の管理",
        "applicationManagement": "アプリケーション管理",
        "networkManagement": "ネットワーク管理",
        "noApplications": {
          "title": "まだアプリケーションがありません",
          "actionButtonText": "アプリケーションの登録"
        },
        "contactUs": "情報を更新したい場合は、直接お問い合わせください",
        "noData": "まだデータがありません",
        "basic": "ベーシック",
        "companyName": "会社名",
        "participantName": "参加者名",
        "participationMode": "参加モード",
        "connectorName": "コネクタ名",
        "connectorVariant": "コネクタのバリエーション",
        "contact": "連絡先",
        "address": "住所",
        "street": "通り",
        "number": "番号",
        "postalCode": "郵便番号",
        "city": "都市",
        "country": "国",
        "phoneNo": "電話番号",
        "contactPerson": "連絡先",
        "email": "メール",
        "dateOfJoining": "参加日",
        "dateOfInvitation": "日付",
        "operator": "演算子",
        "dateOfRequest": "リクエストの日付",
        "url": "URL",
        "status": "ステータス",
        "bpn": "ビジネスパートナー番号",
        "name": "名前",
        "description": "説明",
        "website": "ウェブサイト",
        "dataspaceId": "データスペースID",
        "password": "パスワード",
        "digitalId": "このデータスペースは Digital.ID 有効になっています",
        "disableDigitalId": "このデータスペースでは Digital.ID が有効になっていません",
        "company": "会社 |企業」",
        "connector": "コネクタ |コネクタ」、",
        "application": "アプリケーション |アプリケーション」、",
        "dataoffer": "データ提供 |データオファー」、",
        "visibility": "あなたのデータスペースは現在{access}です",
        "discoverable": "発見可能",
        "private": "プライベート",
        "statusTooltip": {
          "invited": "データスペースへの参加招待が送信されました",
          "inprogress": "招待された人はオンボーディングフォームを送信しました",
          "expired": "14日間の非アクティブな状態が続いたため、招待の有効期限が切れました",
          "withdrawn": "招待が取り下げられました",
          "rejected": "オンボーディングリクエストは拒否されました。詳細については、dih.support{'@'}telekom.com にお問い合わせください",
          "active": "参加者は正常にオンボードされました",
          "failed": "失敗"
        },
        "deleteParticipant": {
          "modal": {
            "title": "参加者を削除",
            "informationText": "参加者に属するコネクタは、確認後にデプロイ解除されます。このアクションは元に戻せません。",
            "successNotificationTitle": "削除がリクエストされました",
            "successNotificationBody": "参加者の削除が要求されています",
            "cancel": "キャンセル",
            "delete": "削除"
          }
        },
        "services": {
          "applicationOrchestration": "アプリケーションオーケストレーション",
          "applicationOrchestrationDesc": "ビジネスアプリケーションをデプロイして管理",
          "identityAccessManagement": "IDとアクセス管理",
          "identityAccessManagementDesc": "ユーザーとリソースへのアクセスを管理します",
          "continuousDelivery": "継続的デリバリー",
          "continuousDeliveryDesc": "デプロイと運用のベストプラクティスを取り入れる",
          "secretCredentialManagement": "シークレットとクレデンシャルの管理",
          "secretCredentialManagementDesc": "トークン、パスワード、証明書へのアクセスを保護、保存、制御する",
          "monitoring": "監視",
          "monitoringDesc": "クエリ、視覚化、アラートの取得、メトリクスとKPIの理解",
          "connectorTest": "コネクタのヘルスチェック",
          "connectorTestDesc": "コネクタのヘルスチェックを実行するサービスです。",
          "catenaXSandbox": "catena-Xサンドボックス",
          "catenaXSandboxDesc": "LivingLab内でCatena-Xサンドボックスを起動して、Catena-X環境で新しいビジネスアプリケーションを開発およびテストしてください。"
        }
      },
      "connectorHealthCheck": {
        "title": "コネクタのヘルスチェック",
        "viewResults": "結果の表示",
        "close": "閉じる",
        "description": "ヘルスチェックを実行するコネクタを1つ以上選択してください。標準のデータ領域操作は、稼働状況チェックの影響を受けません。",
        "connectors": "コネクタ",
        "placeholder": "コネクタを選択",
        "searchInputLabel": "コネクタの検索...",
        "banner": "ヘルスチェックの実行には数分かかる場合があります。結果が利用可能になり次第、通知されます。",
        "action": "開始",
        "history": {
          "connectorName": "コネクタ名",
          "initiated": "開始された",
          "completed": "完了",
          "result": "結果",
          "successMessage": "{connectorName}は期待どおりに動作しています",
          "unsuccessfulMessage": "{connectorName} は期待どおりに動作していません。お問い合わせください」"
        },
        "successNotificationTitle": "コネクタのヘルスチェックが開始されました。",
        "successNotificationContent": "結果が利用可能になると通知されます。",
        "noTest": "まだテストはありません",
        "initiateTest": "テストの開始"
      },
      "specifications": {
        "table": {
          "attribute": "属性",
          "value": "値",
          "cloudProvider": "クラウドプロバイダー",
          "contractStart": "契約開始",
          "contractDuration": "契約期間",
          "cpu": "CPU",
          "ram": "RAM",
          "storage": "ストレージ",
          "maximumConnectorsBookable": "予約可能な最大コネクタ",
          "subscribedConnectors": "サブスクライブされたコネクタ"
        },
        "dataspaceSpecifications": "データスペースの仕様",
        "livinglabCore": "リビングラボコア",
        "livinglabAppLayer": "LivingLabアプリケーションレイヤー"
      },
      "connectorManagement": {
        "connectorManagement": "コネクタ管理",
        "connectorName": "コネクタ名",
        "connectorType": "コネクタタイプ",
        "targetParticipant": "対象参加者",
        "connectorOwner": "コネクタ所有者",
        "url": "URL",
        "status": "ステータス",
        "connectorUrl": "コネクタ URL",
        "connectorUiUrl": "コネクター UI URL",
        "connectorRegistration": "コネクター登録",
        "connectorDeployment":"コネクタ展開",
        "technicalUser": "技術ユーザー",
        "selfDescRegistration": "自己記述登録",
        "connectorDeleteTitle": "コネクタを削除してもよろしいですか?",
        "connectorDeleteDescription": "注意: このアクションは、インフラストラクチャで実行されている実際のコネクタインスタンスを削除または停止しません。削除されると、このコネクタは再登録されるまで DIH ポータルに表示されなくなり、このデータスペース内のデータ トランザクションに利用できなくなります",
        "deleteSuccessMessage": "コネクタが正常に削除されました",
        "saveSuccessMessage": "コネクタの詳細が正常に更新されました",
        "registerConnector": "独自のコネクタを登録",
        "howToConfigure": "コネクタの設定方法",
        "howToDescription": "以下の情報は、外部コネクタを登録し、後で展開するために必要な設定値を示しています。これらの設定により、コネクターが正しく認証され、Dataspaceサービスとやり取りできるようになります。",
        "howToDescription1":"展開前に、コネクターはデータスペースに登録しなければなりません。このフローは登録ステップをカバーします。今後のステップで入力するURLフィールドは後で編集可能なので、まだ最終決定でなくても進めることができます。",
        "supportedEDCVersions": "サポートされている EDC バージョン：",
        "howToInfo": {
          "info1": "iatp.sts.oauth.client.id:この特定のコネクタの技術ユーザーのクライアントID。",
          "info2": "iatp.sts.oauth.client.secret:この特定のコネクタの技術ユーザーの秘密です。",
          "info3": "上記の両方の値はコネクタ登録が完了すれば利用可能になります。登録手続きを完了した後、コネクターを展開できます。"
        },
        "connectorRegistationTitle": "コネクタ登録詳細",
        "location":"ロケーション*",
        "locationError": "位置情報が必要です",
        "connectorRegistrationProgress": "コネクタ登録中",
        "connectorCatalogEndpoint": "コネクタカタログエンドポイント*",
        "connectorUIEndpoint": "コネクタUIエンドポイント（オプション）",
        "connectorRegistrationInfo": "コネクタの登録状況は、データスペースのコネクタ管理セクションで確認できます。",
        "viewConfiguration": "表示構成",
        "name": "名前、",
        "value": "価値",
        "stepToDeployConnector":"コネクタをデプロイするためのステップ",
        "deploymentGuide": "コネクタ展開ガイド",
        "clientIdDummyValue": "コネクタの技術ユーザーのクライアントID",
        "secreteDummyValue": "コネクタの技術ユーザーの秘密",
        "failedConnectorDeploymentTooltip": "コネクタは現在利用できません。展開待ち。"
      }
    },
    "profile": {
      "profile": "プロフィール",
      "userProfile": "ユーザープロファイル",
      "personalInfo": "個人情報",
      "personalDetails": "個人情報と設定",
      "changeDetailsMessage": "詳細を変更したい場合は、お問い合わせください",
      "changeDetailsLinkText": "サポート",
      "memberships": "メンバーシップ",
      "security": "セキュリティ",
      "setUp2FA": "2FAを設定する",
      "accountInformation": "アカウント情報",
      "deleteAccount": "ユーザーアカウントの削除",
      "deleteAccountDescription": "この操作により、お客様の個人アカウントに関連付けられているすべてのデータとデータファイルが削除されます。",
      "accountSecurity": "アカウントのセキュリティ",
      "yourInfomration": "あなたの情報",
      "fullName": "フルネーム",
      "contact": "連絡先",
      "language": "言語",
      "changePassword": "パスワードの変更",
      "please": "お願いします",
      "contactSupport": "サポートに連絡する",
      "toDownload": "この情報をダウンロードする",
      "toDelete": "プロフィールを削除するには",
      "roles": "役割",
      "memberSince": "メンバー登録日",
      "orgLegalName": "組織の正式名称",
      "bpnNumber": "取引先番号(BPN)",
      "commRegNumber": "商業登記番号",
      "vatIdNumber": "VAT番号",
      "hqAddress": "本社住所",
      "legalIdentifier": "正当な識別子",
      "additionalAttributes": "追加の属性",
      "languageSwitcherMessage": "このページの一部は機械またはAIによって翻訳されています。改善できると思いますか？dih.support{'@'}telekom.com までご連絡ください。"
    },
    "plansBenefits": {
      "communicationIntegrity": "コミュニケーションの完全性",
      "protectedConnection": "保護された接続",
      "mutualAuth": "相互認証",
      "stateArtOfCrypto": "最先端の暗号技術",
      "remoteAttestation": "リモート認証",
      "platforInt": "プラットフォームの整合性",
      "configureAndApp": "構成とアプリの統合",
      "dataUsageControl": "データ使用量の制御",
      "definitionOfUsagePolicy": "利用ポリシーの定義",
      "from": "から",
      "month": "月 |月」、",
      "connect": "接続"
    },
    "cookieSettings": {
      "collapsedTitle": "プライバシー設定",
      "collapsedText": "このウェブサイトは、クッキーおよび類似の技術を使用しています。これらは、コンピューターに保存および読み取られる小さなテキストファイルです。「{0}」をクリックすると、処理、ウェブサイトやパートナー間での個々のユーザープロファイルの作成、およびお客様のデータの第三者への転送(その一部は欧州連合以外の国でお客様のデータを処理する)に同意したことになります(GDPR第49条)。詳細については、{1}のセクション2を参照してください。データは、分析、リターゲティング、およびTelekomサイトおよびサードパーティサイトでのパーソナライズされたコンテンツと広告の再生に使用されます。第三者プロバイダーによるデータ処理に関する情報や取り消しの可能性など、詳細情報は、設定および当社のプライバシー情報に記載されています。ここでは、必要なツールだけで{2}できます。",
      "extendedTitle": "プライバシー設定",
      "extendedText": "お客様に最適なウェブサイト体験を提供するために、当社はクッキーを使用しています。これらには、サイトの運用と最適化、テキストチャットやビデオチャットなどのサービス、およびオンラインの使用行動に基づく広告のためのCookieが含まれます。これにより、例えば、お客様が同じデバイスから当社のページに繰り返しアクセスしたかどうかを検出することができます。私たちはあなたが許可するクッキーの選択肢を提供したいと思います:、",
      "onlyRequired": "のみ必須",
      "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
      "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
      "policyLinkTextShort": "プライバシー情報",
      "policyLinkText": "プライバシー情報",
      "rejectLinkText": "続ける",
      "acceptButton": "すべて受け入れる",
      "saveButton": "設定の保存",
      "settingsButton": "設定の変更",
      "showMore": "もっと見る",
      "showLess": "表示を減らす",
      "categoryTitleEssential": "必須のCookie",
      "categoryTitleAnalytics": "分析用Cookie",
      "categoryTitleMarketing": "マーケティングCookie",
      "categoryTitleThirdParty": "他社(独立した第三者プロバイダー)によるサービス",
      "categoryTextEssential": "これらのCookieは、お客様がウェブサイトをナビゲートし、主要な機能を使用するために必要です。オンラインショップでの注文処理やWebページの安全な領域へのアクセスなどの基本機能をサポートしています。また、ユーザーパターンの匿名分析を実行する目的も果たし、これを使用してWebページを継続的に開発および改善します。",
      "categoryTextAnalytics": "これらのクッキーは、ユーザーの行動に対する理解を深めるのに役立ちます。分析Cookieを使用すると、元のプロバイダーまたはサードパーティのプロバイダーによる使用状況および識別データを仮名の使用プロファイルに編集できます。当社は、例えば、ウェブページやサービスへの個々の訪問者の数を決定するため、当社製品のパフォーマンスに関する統計データを収集するため、匿名および仮名情報に基づいて訪問者の使用パターンと訪問者のインタラクションを分析するために、分析Cookieを使用します。この情報は、個人にさかのぼることはできません。",
      "categoryTextMarketing": "これらのクッキーおよび類似の技術は、パーソナライズされた、したがって関連性の高いマーケティングコンテンツの表示を可能にするために使用されます。マーケティングCookieは、興味深い広告コンテンツを表示し、キャンペーンの効果を測定するために使用されます。これは、TelekomのWebサイトだけでなく、他の広告パートナーサイト(サードパーティプロバイダー)でも発生します。これはリターゲティングとも呼ばれます。これは、仮名化されたコンテンツや広告プロファイルを作成したり、他のWebサイトに関連する広告を配置したり、広告やコンテンツを見たターゲットグループに関する洞察を導き出したりするために使用されます。この情報は、個人にさかのぼることはできません。マーケティングおよびリターゲティングツールは、お客様に潜在的に関連性のある広告コンテンツを提供するのに役立ちます。マーケティングCookieを抑制しても、同じ量の広告が表示されますが、関連性が低くなる可能性があります。",
      "categoryTextThirdParty": "Telekomのウェブサイトには、第三者のサービスプロバイダーへのリンクが含まれています。これらのプロバイダーは、自己の責任の下でサービスを提供しています。お客様がTelekomのウェブページにアクセスすると、クッキーまたは類似の技術がデータを記録し、それを第三者に送信します。これは、Telekom自身の目的の一部を目的としています。第三者自身の目的のためにさらなる処理が行われる範囲、目的、および法的根拠は、第三者のデータプライバシー情報に記載されています。独立した第三者プロバイダーに関する情報は、データプライバシー情報に記載されています。"
    },
    "consultation": {
      "createDescription": "当社の専門家チームにリクエストを送信していただければ、折り返しご連絡いたします。",
      "tellUsMore": "ご要望について詳しく教えていただけますか?",
      "checkConsent": "私は、私の連絡先データがT-Systemsの営業チームに提供され、連絡を受けることに同意します。",
      "back": "戻る",
      "sendRequest": "リクエストを送信",
      "successMsgtitle": "リクエストが成功しました!",
      "successMsgBody": "リクエストが送信されました...数日後に回答が届きます"
    },
    "notifications": {
      "notifications": "通知",
      "inbox": "受信トレイ",
      "clearAll": "すべてクリア",
      "blankState": {
        "heading": "まだ通知はありません",
        "description": "通知を受け取ると、ここに通知が表示されます",
        "actionButtonText": "リフレッシュ"
      },
      "actionMessage": {
        "seeRequest": "リクエストを参照してください",
        "here": "ここ",
        "checkResult": "結果を確認してください"
      },
      "goToMyAccount": "{myAccountLink}で新しいロール情報を表示してください。"
    },
    "statusTile": {
      "noMembership": {
        "title": "まだメンバーシップがありません",
        "subTitle": "データスペースを参照して1つを結合する",
        "getConnected": "接続する"
      }
    },
    "settings": {
      "organization": {
        "pageTitle": "私の組織",
        "orgDetails": "組織の詳細",
        "teamMembers": "チームメンバー",
        "groups": "グループ",
        "groupsOverview": "グループ概要",
        "technicalUsers": "技術ユーザー",
        "singleSignOn": "シングルサインオン",
        "mapGroupClaims": "地図群の主張"
      },
      "teamMembers": {
        "title": "ユーザー管理",
        "description": "このセクションは、組織のユーザーの管理に役立ちます"
      },
      "groups": {
      "title": "グループ経営",
      "description": "グループは組織内の部署を表します。グループのユーザーは常にメイン組織のメンバーでもあります。",
      "createGroup": "グループ作成",
      "groupName": "グループ名",
      "groupDesc": "グループの説明",
      "groupCreateNote": "メンバーは作成後にこのグループに割り当てられます。追加できるのは既存の組織メンバーのみです。",
      "membersTitle": "メンバー",
      "members": "メンバー",
      "createdBy": "作成者",
      "createdOn": "作成",
      "contactPerson": "連絡担当者",
      "actions": "行動",
      "groupMembers": "グループメンバー",
      "groupDetails": "グループ詳細",
      "groupMembersDescription": "既存の組織メンバーをこのグループに割り当てる",
      "disableAddMembers": "グループメンバーシップは SSO クレームによって管理されています。ID プロバイダーを使用してグループへのアクセスを管理してください。",
      "addMembers": "メンバー追加",
      "fullName": "フルネーム",
      "addedToGroup": "グループへの追加",
      "addMembersTo": "“{name}” にメンバーを追加します。",
      "addToGroup": "グループへの追加",
      "addMemberDescription": "組織のメンバーから選びましょう。選ばれたメンバーは、メイン組織のメンバーとして残ります。",
      "membersSelected": "選出されたメンバー",
      "editSuccess": "グループ詳細の編集が成功しました",
      "addMemberSuccess": "選択したユーザーがグループに正常に追加されました",
      "duplicateGroupNameError": "この名前のグループはすでに存在しています。別の名前をお選びください。"
    },
      "inviteUser": {
        "inviteUsers": "ユーザーを招待する",
        "newEmailAddress": "新しいチームメンバーのメールアドレス",
        "chooseRole": "役割を選択",
        "whichRoleToSelect": "どの役割を選択すべきですか?",
        "roleNote": "選択したロールは、招待されるすべてのユーザーに付与されます",
        "roleError": "利用可能なオプションから少なくとも1つのロールを選択してください",
        "roleErrorShort": "少なくとも1つのロールを選択してください",
        "cancel": "キャンセル",
        "sendInvite": "招待を送信",
        "fullName": "フルネーム",
        "status": "ステータス",
        "role": "役割",
        "memberSince": "メンバー登録日"
      },
      "inviteSuccess": {
        "title": "招待の概要",
        "totalInvitation": "{count}招待が送信されました |{count} 個の招待が送信されました」",
        "description": "{count} 件の招待は、メールアドレスがすでに Data Intelligence Hub に存在するため送信されませんでした | {count} 件の招待は、メールアドレスがすでに Data Intelligence Hub に存在するため送信されませんでした",
        "actionContinue": "続行"
      },
      "roleChange": {
        "areYouSure": "これらの役割を変更してもよろしいですか?",
        "yeahSure": "はい、きっと"
      },
      "technicalUser": {
        "title": "技術ユーザー認証",
        "createdAt": "作成済み",
        "clientId": "クライアントID",
        "clientSecret": "クライアントの秘密",
        "sendCredEmailBtn": "認証情報を私のメールに送信してください",
        "sendCredEmailDescription": "あなたの認証情報を含むメールがあなたのメールアドレスに送信されます。数分後に受信箱をチェックしてください。",
        "use": "用途 その",
        "clipboardText": "クライアントIDをクリップボードにコピーするためのアイコン",
        "successText": "あなたの認証情報を含むメールが、あなたのメールアドレスに正常に送信されました",
        "actions": "行動"
      },
      "sso": {
        "description": "SSO ベースのログインを有効にするには、組織の ID プロバイダーを接続してください。",
        "microsoftEntraId": "Microsoft EntraID",
        "tenantId": "テナント ID:",
        "clientId": "クライアント ID:",
        "redirectURI": "リダイレクト URI:",
        "groupClaimMappings": "グループクレームのマッピング",
        "autoAssign": "Identity Provider トークン内のクレームに基づいて、ユーザーを自動的に グループへ割り当てます。",
        "setupGroupClaims": "グループクレームを設定",
        "noIdentityProviderConfigured": "ID プロバイダーが設定されていません",
        "contact": "外部 ID プロバイダーを設定するには、dih.support{'@'}telekom.com までお問い合わせください。",
        "claimName": "請求名",
        "mappings": "マッピング",
        "idpClaimValue": "Identity Provider 請求値",
        "dihGroups": "グループ",
        "groupMappingDisclaimer": "すべてのマッピングされたユーザーはデフォルトでビジネスユーザーロールを受け取ります。",
        "groupClaimNameDescription": "Identity Provider トークンから ポータル内のグループにグループ値をマッピングする。",
        "claimNameDisclaimer": "グループの価値を持つ Identity Provider トークンのキー。",
        "claimNameLabel": "グループがトークンで名前を主張する*",
        "noMappingHeading": "まだマッピングが定義されていません",
        "noMappingSubheading": "ユーザーを自動的に グループに割り当てるマッピングを追加。",
        "addMapping": "マッピングの追加",
        "businessUserDisclaimer": "すべてのマッピングされたユーザーはデフォルトでビジネスユーザーとして割り当てられています。",
        "businessUserDisclaimer2": "役割割り当ては別途管理されます。",
        "reviewChanges": "レビュー変更",
        "confirmSave": "確認して保存する",
        "confirmModalDisclaimer1": "変更は保存後の次のユーザーログイン時に有効となります。",
        "confirmModalDisclaimer2": "現在割り当てられたユーザーは次のログインまで削除されません。",
        "confirmBeforeSaving": "保存前に以下のマッピング変更を確認してください。"
      }
    },
    "completeInviteProfile": {
      "title": "アカウントを完了してください",
      "description": "Telekom Data Intelligence Hubに招待されました。アカウントを完成させるには、必要な情報を入力してください。",
      "firstName": "名",
      "firstNamePlaceholder": "名を入力してください",
      "lastName": "姓",
      "lastNamePlaceholder": "姓を入力してください",
      "email": "メール",
      "emailPlaceholder": "メールアドレスを入力してください",
      "organisation": "組織",
      "organisationPlaceholder": "組織を入力してください",
      "enterPassword": "パスワードを入力してください",
      "dataPrivacyCheck": "私は、私の個人データが{dataAndPrivacyStatement}に示されている目的に従って保存および処理されることを承認します。",
      "termsAndConditionsCheck": "私は、Data Intelligence Hubの{termsandcondition}を読み、遵守することを確認します。",
      "termsandcondition": "利用規約",
      "dataAndPrivacyStatement": "データプライバシーに関する声明",
      "cancel": "キャンセル",
      "submit": "提出",
      "success": {
        "title": "アカウントが完了しました",
        "description": "ログインページに移動します",
        "actionContinue": "続行"
      }
    },
    "workbench": {
      "incomingDataAgreements": {
        "title": "受信データ契約",
        "addedOn": "追加されました",
        "expiresOn": "有効期限",
        "providedBy": "提供元",
        "dateAddedOn": "追加された日付",
        "noFilesAttached": "この契約契約には現在ファイルが添付されていません",
        "noAgreementsMessage": "受信データ契約はありません",
        "receivingData": "データを受信しています",
        "dataReceived": "ダウンロード済み",
        "error": "エラーが発生しました",
        "transferInitiated": "転送が開始されました",
        "transferCompleted": "転送が完了しました!",
        "view": "表示",
        "successDownload": "データ資産は正常に受信されました",
        "errorDownload": "{filename}のファイルのダウンロードがエラーで中止されました。もう一度やり直してください",
        "viewAggreement": "契約の表示",
        "agreeText": "ファイルをダウンロードすることにより、お客様は本契約の{contractTerms}を遵守することに同意するものとします。",
        "contractTerms": "契約条件",
        "includedFile": "インクルードファイル",
        "createdOn": "作成日",
        "fileType": "ファイルの種類",
        "downloadError": "受信データ同意書のフェッチに失敗しました",
        "downloadSuccess": "データ資産は正常に受信されました"
      },
      "contractDetails": {
        "termsAndPolicies": "規約とポリシー",
        "offerBy": "オファーの作成者",
        "addedOn": "追加されました",
        "expiresOn": "有効期限",
        "product": "製品",
        "totalFiles": "合計ファイル数",
        "description": "説明",
        "contractID": "契約ID",
        "contractTerms": "契約条件",
        "files": "ファイル",
        "parameters": "パラメータ",
        "referencePeriod": "参照期間",
        "location": "場所",
        "additionalLinks": "追加リンク",
        "dihMainPage": "DIHメインページ",
        "download": "ダウンロード",
        "search": "検索",
        "title": "タイトル",
        "createdOn": "作成日",
        "kpiName": "KPI名",
        "fileType": "ファイルタイプ",
        "schema": "スキーマ",
        "dashboard": "ダッシュボード",
        "selectAll": "すべて選択",
        "deselectAll": "すべて選択解除",
        "transfer": "転送",
        "downloadSelected": "選択したものをダウンロード",
        "noTermsPolicy": "現時点では、データプロバイダは、この契約におけるデータの使用に関するルールを指定していません。",
        "youCan": "できる",
        "youCant": "できません",
        "youMust": "あなたはしなければならない",
        "respectContent": "ライセンス契約の内容を尊重してください。",
        "licenceAgreement": "ライセンス契約",
        "noAttachment": "まだ添付ファイルはありません",
        "termsandcondition": "利用規約",
        "resellData": "データを再販する",
        "youCanUseDataCommercial": "データを商用目的で使用してください",
        "youCanProcessData": "欧州連合外のインフラストラクチャ上のデータを処理します",
        "youCanEmpty": "現時点では、データプロバイダはこの契約内でデータの使用に関する許可を指定していません",
        "youCantEmpty": "現時点では、データプロバイダはこの契約内でのデータの使用を禁止する規定を指定していません",
        "youMustEmpty": "現時点では、データプロバイダはこの契約内でのデータの使用に関する義務を指定していません。"
      }
    },
    "messages": {
      "noDataAvailable": "利用可能なデータがありません",
      "noMatchFound": "一致するものが見つかりませんでした",
      "maximumFileSize": "最大ファイルサイズ",
      "suitableFileFormats": "適切なファイル形式",
      "loading": "読み込んでいます...",
      "dragDropText": "またはここにドラッグ&ドロップ"
    },
    "pageNotFound": {
      "title": "おっと!お探しのページはまだ存在しないようです。",
      "subtitle": "それまでの間、私たちの他のリソースをチェックしてください。それがあなたに役立つかもしれません。"
    },
    "unauthorized": {
      "pageNotAccessible": "おっと!お探しのページは、あなたの許可ではアクセスできないようです。",
      "reachOutToAdministrator": "管理者に連絡して、アクセスについてさらにお問い合わせください。",
      "checkOtherResources": "それまでの間、他のリソースをチェックしてください。"
    },
    "helpResources": {
      "needHelp": "適切なプラン、詳細情報、技術的な質問を見つけるのに助けが必要ですか?",
      "FAQ": "「よくあるご質問」",
      "FAQDescription": "請求からプライバシーまで、より一般的な答えを見つける",
      "browse": "ブラウズ",
      "demos": "デモ",
      "demosDescription": "あなたの産業セクターに関連するユースケースとデモを見つけてください",
      "glossary": "用語集",
      "glossaryDescription": "Data Intelligence Hub、IDSA、Catena-X、Gaia-Xなどに関連する用語と定義を見つけてください。"
    },
    "feedbackCard": {
      "giveUsFeedback": "足りないものについてフィードバックをください？",
      "contactUs": "お問い合わせ"
    },
    "requestDataspaceJoin": {
      "title": "{dsName}への接続をリクエスト",
      "basic": "ベーシック",
      "orgName": "組織名:",
      "contact": "連絡先",
      "address": "アドレス:",
      "name": "名前:",
      "email": "メール:",
      "joinReasonTitle": "なぜデータスペースを結合したいのか教えてください。",
      "joinConsent": "上記の詳細をデータスペースの所有者と共有することに同意します",
      "sendRequest": "リクエストを送信"
    },
    "applications": {
      "myApplication": "マイアプリケーション"
    },
    "externalConnection": {
      "title": "外部接続マネージャー",
      "noConnectionConfigureTitle": {
        "title": "まだ接続が設定されていません",
        "newConnection": "新しい接続"
      },
      "request": {
        "connectionDetails": "接続の詳細",
        "preferConnection": "サーバー接続の優先モードを選択してください",
        "selectConnection": "接続を選択",
        "ageeTerms": "私はここに同意し、上記の私のすべての個人情報とデータが正確であることを確認します。",
        "grantConsent": "私は、提供された接続を通じて資産の転送を容易にするために、このデータの処理と保存についてTelekom Data Intelligence Hubに同意します。",
        "back": "戻る",
        "addConnection": "接続を追加",
        "save": "保存",
        "verifyConnectivity": "接続性の確認",
        "checkingConnection": "接続を確認しています",
        "connectionVerified": "接続が確認されました",
        "error": "エラー",
        "requestSuccessTitle": "追加に成功しました!",
        "requestSuccessText": "接続の詳細が正常に追加されました。",
        "requestUpdatedTitle": "更新に成功しました!",
        "requestUpdatedText": "接続の詳細が正常に更新されました。",
        "maxConnectionReached": "空き接続の最大数に達しました。"
      },
      "delete": {
        "title": "接続の削除",
        "description": "この接続を削除してもよろしいですか?",
        "cancel": "キャンセル",
        "delete": "削除",
        "requestDeleteSuccessTitle": "削除に成功しました!",
        "requestDeleteSuccessText": "接続が正常に削除されました。"
      },
      "transfer": {
        "title": "接続マネージャー",
        "connectionDetails": "接続の詳細",
        "type": "タイプ",
        "hostName": "ホスト名",
        "rootPath": "ルートパス",
        "authType": "認証タイプ",
        "username": "ユーザー名",
        "verificationStatus": "確認ステータス",
        "disclaimer": "免責事項",
        "disclaimerText": "お客様の選択を確認することにより、お客様は選択した接続がTelekom Data Intelligence Hubの制御を超えていることを認識します。したがって、ストレージの不足、ネットワーク接続、アクセスと認証の制限、その他の関連する考慮事項など、外部要因から生じるデータ転送の問題については、お客様が責任を負うものとします。",
        "confirmSelection": "選択の確認",
        "newConnection": "新しい接続",
        "noConnectionModalTitle": "まだ接続がありません",
        "noConnectionModalDesc": "下のボタンをクリックすると、新しい接続を作成できます。",
        "noConnectionAddNewButton": "新しい接続を追加",
        "successModalTitle": "転送には通常より時間がかかります",
        "successModalDesc": "ファイル転送が完了したら、通知をお送りします。",
        "successModalAction": "受信するデータに移動"
      }
    },
    "error": {
      "pageNotFound": "ページが見つかりません (404)",
      "unauthorized": "不正アクセス (403)"
    },
    "helpWidget": {
      "askSupport": "サポートに問い合わせる",
      "chatboxTitle": "ヘルプチャット",
      "chatboxSubtitle": "Telekom Data Intelligence Hubサポート",
      "defaultMessage": {
        "body": "こんにちは。Telekom Data Intelligence Hubサポートチャンネルへようこそ。以下のオプションを選択してください。"
      },
      "whatCanWeHelpWith": "今日は何かお手伝いできることはありますか?",
      "suggestedAnswers": {
        "knowledgeBase": "ナレッジベース、ドキュメント、FAQ",
        "contactSupport": "サポートに連絡する",
        "contactSales": "営業担当に連絡"
      }
    },
    "partnerNetworkManagement": {
      "title": "パートナーネットワーク管理",
      "hint": "このページでは、ユーザーがパートナー組織の招待状況をTelekom Data Intelligence Hubに招待し、監視することができます。",
      "noInvitations": {
        "title": "あなたはまだ組織を招待していません",
        "actionButtonText": "組織を招待する"
      },
      "overview": {
        "title": "パートナー招待の概要",
        "actionButtonText": "組織を招待",
        "dateOfInvitation": "招待日",
        "resendInvitation": "招待状を再送",
        "deleteInvitation": "招待を削除",
        "resendReminderInfo": "最後の招待メールから24時間が経過するとすぐに招待を再送信できます。",
        "invitedBy": "招待者"
      },
      "information": {
        "title": "重要な情報",
        "description": "連絡担当者は、Telekom Data Intelligence Hub内で「管理者」の役割を引き受けます。管理者として、自分の組織からユーザーを追加または削除する権限、ロールを監督する権限、および当社が提供するサービスに関する商業的な決定を下す権限を持ちます。組織のオンボーディングの次のステップは、担当者にメールで伝えますので、「パートナー招待の概要」ページで進捗状況をモニタリングしていただけます。"
      },
      "invite": {
        "additionalText": "組織を1つずつ招待するか、一括で招待するかを検討し、以下で選択してください。",
        "bulkInvite": "一括招待",
        "bulkInviteHint": "一括招待 (>5 回の招待) を行いたい場合は、このオプションを選択してください。",
        "limitationHint": "制限:最大5組織。さらに追加するには、「一括招待」を選択してください。",
        "singleInvite": "単一の招待",
        "singleInviteHint": "招待する団体が5つ以下の場合は、このオプションを選択してください。",
        "orgNameLabel": "パートナー組織名を入力してください",
        "emailLabel": "連絡先のメールアドレスを入力してください",
        "groupInvite": "グループ招待",
        "groupInviteHint": "複数のグループを招待する場合は、このオプションを選択してください。",
        "groupInviteInfo": "複数のグループを追加できます。上限: グループ招待は最大5件です。",
        "groupDetails": "グループ詳細:",
        "groupSelect": "追加するグループを選択してください",
        "groupRequired": "グループ名は必須項目です",
        "groupUnique": "このグループはすでに追加されています",
        "groupCreate": "+ 新しいグループを作成"
      },
      "inviteStatus": {
        "INVITED": "招待された",
        "COMPLETED": "Accepted",
        "FAILED": "拒否"
      },
      "upload": {
        "hint": "複数の組織を招待するには、以下の操作を行ってください：",
        "step1": "以下のリンクからテンプレートファイルをダウンロードしてください",
        "step2": "招待者の詳細を提供されたファイルに記入してください",
        "step3": "提供されたエリアにファイルをアップロードし、",
        "downloadTemplate": "テンプレートをダウンロード",
        "templateHeader": {
          "organizationName": "organization_name",
          "email": "メール"
        },
        "templateFileName": "bulk_invitations_template.csv",
        "learnMore": "一括招待について詳しく知りたい場合は、{clickHere}をご覧ください。",
        "clickHere": "ここをクリック"
      },
      "report": {
        "invitationsInProgress": "{type}招待を処理中です",
        "invitationsSent": "招待が送信されました",
        "error": {
          "errorsInInvitations": "{result}招待のエラーが送信されました",
          "single": {
            "invalidEmail": "メールアドレスが無効です",
            "pleaseEnterValidEmail": "有効なメールアドレスを入力してください",
            "pleaseEnterValidOrganization": "組織名フィールドには、文字、数字、スペース、および次の文字のみを含めることができます: & _ . - ' , ( ) +",
            "emailUnique": "メールは一意である必要があります",
            "pleaseEnterValidName": "有効な名前を入力してください"
          },
          "bulk": {
            "allowedFileExtension": "拡張子が.csvのファイルのみが許可されます",
            "fileIsTooBig": "ファイルが大きすぎます。最大1MBのファイルをアップロードできます」",
            "formatMismatch": "ファイルは予期された形式と一致しません。提供されたテンプレートを使用して、もう一度やり直してください。",
            "duplicateEmail": "ファイルには{number} {duplicate}があります",
            "duplicate": "重複 |duplicates",
            "fileHasNoEntries": "ファイルにはエントリがありません",
            "invalidEmailAddresses": "{number}メールアドレスは無効です。",
            "invalidOrganizationNames": "{number}個の組織の名前が無効です。",
            "organizationAlreadyInvited": "{number}個の組織はすでにあなたの組織から招待されています。",
            "kindlyDownloadReport": "詳細を表示するには、レポートをダウンロードしてください",
            "limitExceededError": "契約契約に基づく最大コネクタ クォータを超えました。招待できる参加者は {limit} 人までです。契約を修正し、クォータを増やすには、{email}に連絡してください。さらに、保留中の招待を撤回して、クォータを解放することもできます。",
            "noQuotaLeftError": "契約契約に従って、最大コネクタクォータを使い果たしました。これ以上参加者を招待することはできません。契約を修正し、クォータを増やすには、{email}に連絡してください。さらに、保留中の招待を撤回して、クォータを解放することもできます。"
          },
          "processing": {
            "DUPLICATE_EMAILS": "重複するメールが検出されました。",
            "EMAIL_ALREADY_EXIST": "メールは既に存在します。",
            "SOMETHING_WENT_WRONG": "問題が発生しました。",
            "INVALID_EMAIL_FORMAT": "メール形式が無効です。",
            "ALREADY_REGISTERED_DATASPACE_USER": "ユーザーはすでに {dataspaceName} の一員です。"
          }
        },
        "template": {
          "fileName": "bulk_invitations_report.csv"
        }
      },
      "abort": {
        "title": "招待を中止",
        "confirmText": "このプロセスを閉じてもよろしいですか?",
        "informationText": "あなたの招待状は送信されません。"
      },
      "switchForm": {
        "title": "変更を破棄する",
        "confirmText": "フォームを切り替えてもよろしいですか?",
        "informationText": "お客様の変更は保持されません。"
      }
    },
    "discover": {
      "welcome": {
        "title": "信頼できるパートナーやプロバイダーからのデータ提供を発見する",
        "description1": "データドリブンな意思決定を行います。",
        "description2": "データは、意思決定、市場細分化、リードジェネレーションのバックボーンなど、さまざまな重要な機能を提供し、事業運営において極めて重要な役割を果たします。データは、製品開発の成否を左右したり、サプライチェーンのロジスティクスを最適化したり、目標を前進させるために必要な結論を導き出すために必要な洞察をAIに提供したりすることができます。",
        "description3": "Telekomのデータインテリジェンスハブは、ドイツ全土のデータプロバイダーに統一されたプラットフォームを提供しています。選択肢を検討し、詳しく調べてみてください:データのニーズに最適なものが見つかるかもしれません。私たちは常にデータプロバイダーのネットワークを拡大しているため、お客様の正確なニーズが現在のデータオファリングでカバーされていない場合でも、見知らぬ人ではありません。",
        "buttonLabel": "データ製品を探索する"
      },
      "dataOffers": {
        "title": "データオファー",
        "filter": {
          "subjectAreas": "サブジェクトエリア",
          "dataOfferingType": "データ提供タイプ",
          "dataProvider": "データプロバイダ"
        },
        "tiles": {
          "productType": "構成可能なデータ製品",
          "dataspaceName": "Data Intelligence Hubのデータスペース",
          "subjectArea": "サブジェクトエリア",
          "massmovementAnalytics": "massmovementの分析",
          "termsOfUse": "利用規約",
          "licensedRestricted": "ライセンス済み、制限付き",
          "viewOffer": "オファーの表示",
          "product1": {
            "name": "モーションデータによるトラフィック分析",
            "summary": "移動の方向、出発地、目的地など、ドイツの詳細な移動行動統計により、あらゆる地域のさまざまな空間レベルでの分析が可能になります。"
          },
          "product2": {
            "name": "Motion DataによるTraffic Analytics PRO",
            "summary": "移動方向、出発地、目的地など、ドイツでの詳細な移動測定により、いつでも、どの地域でも、異なる空間レベルでの分析と比較が可能になります。"
          },
          "product3": {
            "name": "モーションデータによるビジターアナリティクスPRO",
            "summary": "日次および時間単位の合計ユーザー数、社会人口統計学的な洞察、ドイツ全土の任意の地域の訪問者の起源の詳細など、公共の移動パターンによる訪問行動に関する情報を分析します。最大規模のサンプルサイズの1つと前例のない空間精度の利点を組み合わせた、オンサイト訪問行動のための次のレベルの分析オプション。"
          }
        },
        "offerDetails": {
          "title": "オファーの詳細",
          "requestADemo": "デモをリクエストする",
          "orderNow": "今すぐ注文",
          "productOverview": {
            "title": "製品概要",
            "whatUseCasesAreAddressed": "どのようなユースケースに対応していますか?",
            "exampleCarousel1": {
              "title": "主要なイベントの評価",
              "text": "イベント参加者についてより深い洞察を得て、物流上のハードルを効果的に戦略化し、対処し、適切なイベント内のベンダーとスポンサーを選択し、より高い空間解像度で群衆密度データを活用してセキュリティ対策を優先します。"
            },
            "exampleCarousel2": {
              "title": "観光計画への洞察",
              "text": "観光当局は、訪問データを活用して資源計画と配分を強化し、観光ホットスポットにおけるより良いインフラの開発を促進することができます。これには、ピーク時の歩行者交通分析に応じたシームレスな交通ネットワークの実装、効率的なターゲットマーケティングの実施、緊急時および安全サービスの計画が含まれます。」"
            },
            "exampleCarousel3": {
              "title": "ショッピングセンターと小売業への洞察",
              "text": " 小売業のインサイトは、ショッピングセンター、アウトレット、またはショッピングストリートが引き付ける潜在的な顧客の数と、彼らがどこから来たのかを明らかにすることができます。訪問者の滞在時間、社会人口統計学的構成、消費力に関するデータを提供します。これらのパターンを経時的に分析することで、訪問者の行動の傾向を特定できます。また、インサイトは、より優れた代替ロケーションがあるかどうかを判断し、競合他社の状況を評価するのにも役立ちます。」"
            },
            "exampleCarousel4": {
              "title": "都市計画と評価",
              "text": "動的な人口データの分析により、住民のニーズを満たすための住宅地とインフラの効率的な計画が可能になります。リソースの効率的な使用は、アプリケーションの別の重要な領域です。したがって、都市はエネルギー消費を削減し、持続可能性に貢献できます。"
            },
            "fromDataIntelligenceHub": {
              "title": "Telekom Data Intelligence Hubから何を受け取りますか?",
              "ol": {
                "1": "データプロバイダー(Motion Data from T-Systems International GmbH)にデモをリクエストすると、このデータ製品に関する詳細な洞察を信頼できる専門家から得ることができます。",
                "2": "データ提供者から注文可能な製品の場合 (T-Systems International GmbH のモーションデータ): "
              },
              "ul": {
                "1": "購入したデータ製品レポートは、選択した時間範囲、場所、および要求されたメトリックのCSVファイルの形式で受信されます。",
                "2": "Connect & Integrate'アプリケーションが提供され、データプロバイダに接続し、購入したレポートにアクセスすることができます。",
                "3": "レポートは、'Connect & Integrate'アプリケーションの'Consume'ビューからダウンロードできます。",
                "4": "さらに、購入したデータ製品に対してMotionDataからダッシュボードソリューションをリクエストできます。",
                "5": "ドイツ語と英語の営業時間中にメールとホットラインでサポートとサービスデスクが利用可能"
              }
            }
          },
          "generalInformation": {
            "availability": "利用可能な時間範囲",
            "contactProvider": "連絡先プロバイダ",
            "coverage": "地理的な範囲",
            "documentation": "ドキュメンテーション",
            "guide": "スタートガイド",
            "help": "ヘルプ",
            "message": {
              "coverage": "他の国の訪問者情報を購入したいですか?{link}",
              "coverageLinkText": "お問い合わせ",
              "segmentation": "詳細については{link}を確認してください。",
              "segmentationLinkText": "私たちの知識ベース"
            },
            "missing": {
              "availability": "N/A",
              "coverage": "地理的な範囲が指定されていません。",
              "description": "説明はありません。",
              "provider": "不明なプロバイダです。",
              "segmentation": "空間セグメンテーションは利用できません。",
              "source": "利用可能なデータソースがありません。",
              "visualization": "データの視覚化はありません。"
            },
            "mockData": {
              "dataSpace": "データインテリジェンスハブデータスペース",
              "dataProvider": "T-Systems International GmbHのモーションデータ",
              "dataSource": "ドイツのDeutsche Telekomのネットワーク内の携帯電話加入者(ローミングを含む)の匿名化および集約されたシグナリングデータ(アクティブおよびパッシブ)",
              "dataVisualization": "データプロバイダーからのリクエストに応じて、洞察力に富んだ使いやすいダッシュボードを利用できます。",
              "description": "ビジターアナリティクスは、ドイツ国内のどの場所からでもオンサイト訪問行動を分析できるオプションを提供します。Deutsche Telekomのセルラーネットワークから提供された匿名化されたモバイルシグナリングデータから得られた履歴データを活用し、最大規模のサンプルサイズの1つと前例のない空間精度の利点を組み合わせることで、ビジター分析により、企業や機関はスマートなデータドリブンな意思決定で成長を加速するための最適な戦略を策定できます。このデータ製品は、CSVファイル形式のレポート形式で利用でき、Data Intelligence Hubデータスペースを介して信頼できるコネクタソリューションを介して配信されます。",
              "from": "2024年1月7日",
              "geographicalCoverage": "ドイツ",
              "geoLocationData": "ジオロケーションデータ",
              "location": "ドイツ、フランクフルト・アム・マイン",
              "locationType": "本社",
              "logo": "testLogoString",
              "massMovementAnalytics": "マスムーブメント分析",
              "spatialSegmentation": "任意の位置(ポリゴンまたはx/y座標で定義)と150 m / 300 mの特定のバッファを持つ",
              "to": "現在",
              "verificationLabel": "T-Systems Gaia-X Digital Clearing Houseノードによって検証された法人"
            },
            "provider": "データプロバイダ",
            "segmentation": "空間セグメンテーション",
            "source": "データソース",
            "title": "一般情報",
            "visualization": "データの可視化"
          },
          "sampleData": {
            "title": "サンプルデータ",
            "dataPackage": "データパッケージ",
            "description": "説明",
            "descriptionText": "ユニークビジター数は、時間単位(開始時間の1日ごとまたは1時間ごと)に加えて、年齢、性別、ホームゾーン(郵便番号/郡)、ローミング情報ごとに分類されたデイリービジターカウントです。",
            "sampleDataFile": "サンプルデータファイル",
            "sampleDataFileDescription": "提供されたPOI(ポイントオブインタレスト)に対する毎日のユニークビジターカウント",
            "schemaInformation": "スキーマ情報",
            "referenceDocumentation": "リファレンスドキュメント",
            "totalFiles": "合計データファイル",
            "fileName": {
              "pointsOfInterest": "関心のあるポイント",
              "productDescription": "製品の説明",
              "referenceShape": "参照シェイプファイル",
              "reports": "レポート",
              "roamerReference": "Roamerリファレンスの説明"
            }
          },
          "termsOfUse": {
            "allowed": "できます:",
            "mandatory": "あなたはしなければならない:",
            "mockData": {
              "mock1": "データを商用目的で使用してください",
              "mock2": "欧州連合外のインフラストラクチャに関するデータを処理する",
              "mock3": "データを再販する",
              "mock4": "ライセンス契約の内容を尊重してください",
              "mock5": "一般規約とConditions_English",
              "mock6": "一般規約とConditions_German"
            },
            "notAllowed": "できません:",
            "title": "利用規約"
          },
          "additionalInformation": {
            "label": "フィールドのラベル:",
            "mockData": {
              "description": "メタデータブロックの説明。Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            },
            "title": "追加情報"
          }
        },
        "orderVAPro": {
          "title": "データ主導の意思決定を行う!",
          "step1SubTitle": "プロバイダーが要求したフィールドに従ってデータ オファーを構成する",
          "step2SubTitle": "エリア仕様に関する情報を提供する",
          "step1of4": "ステップ 1/4",
          "step2of4": "ステップ 2/4",
          "step3of4": "ステップ 3/4",
          "step4of4": "ステップ 4/4",
          "features": {
            "title": "ビジター分析プロ",
            "feature1": "高解像度で最大150m半径の事前定義ポリゴンをサポート",
            "feature2": "注文ごとに複数の日とポリゴンの選択が可能",
            "feature3": "製品には,ユニーク訪問者数およびその他の主要な指標の時間単位および日単位のデータが含まれています",
            "feature4": "ダッシュボードとコンサルティングはリクエストに応じてご利用いただけます",
            "feature5": "信頼できる Connect & Integrate ソリューションを介して,データ ファイルをシームレスかつ安全に配信するモード。"
          },
          "dateTitle": "時間範囲",
          "dateTooltip": "Visitor Analytics Pro レポートを分析する期間を最低 1 日から指定します。時間範囲とは,データが収集,測定,処理され,分析の準備が整う期間を指します。",
          "areaSelectionTitle": "エリア選択",
          "areaSelectionTooltip": "データ分布におけるエリア選択には,データセットを絞り込んで,特定の地理的関心領域に関連する観測値または測定値のみを含めることが含まれます。",
          "validDays": "有効日数の合計数:",
          "segmentTypeLabel": "空間セグメンテーションタイプの選択",
          "informationTypeLabel": "この情報をどのように提供しますか",
          "totolPOICount": "POIの合計数:",
          "confirmSelection": "選択の確認",
          "totalPOICounts": "POIの合計数:",
          "priceFetchingProgressMsg": "価格を取得しています...",
          "priceFetchingError": "価格を取得できません",
          "totalPriceText": "合計価格:",
          "vatText": "(VAT を除く)",
          "premiumCustomerHighlight": "10.000 €を超える注文の場合,あなたは当社のプレミアムカスタマーです。さらなるコラボレーションのオプションについて話し合うために,別の電子メールで連絡を取る予定です。」",
          "reviewPageHeading": "注文の概要",
          "name": "名前",
          "monthlyCharges": "月額料金",
          "oneTimeCharges": "1 回限りの料金",
          "yourSelectedProduct": "選択した製品",
          "product": "製品",
          "timeSelection": "時間選択",
          "type": "タイプ:",
          "areaSelection": "エリア選択",
          "spatialInput": "空間入力: 関心のあるポイント (POI)",
          "inputType": "入力タイプ: 定義済みのPOIを選択",
          "viewMap": "地図を表示",
          "additionalServices": "追加サービス",
          "supportServices": "サポートサービス",
          "essentialSupport": "エッセンシャルサポート 5/8",
          "totalAmount": "合計金額(ユーロ)",
          "resultSuccessHeading": "ご注文いただきありがとうございます",
          "resultParaText1": "あなたのファイルはまもなく利用可能になります。しばらくお待ちいただきありがとうございます。",
          "resultParaText2": "ご質問やご質問がございましたら,お気軽にお問い合わせください。",
          "membershipBtn": "マイメンバーシップに移動",
          "mapPoi": "POI:",
          "mapCity": "都市:",
          "mapCoordinates": "座標:",
          "pickDate": "日付を選択",
          "from": "から",
          "to": "に",
          "selectDate": "日付を選択してください",
          "poiDropdown": "関心のあるポイント (POI)",
          "mapSelection": "地図上の関心のあるポイント (POI) を選択します",
          "fileUpload": "優先POIのシェープファイルをアップロードする",
          "predefinedSelection": "定義済みの関心のあるポイントを選択"
        }
      }
    },
    "ospOnboarding": {
      "help": "ヘルプ",
      "welcome": {
        "title": "Catena-Xへようこそ - 自動車ネットワーク",
        "card": {
          "note": "Catena-Xへの貴社の登録を完了するには、以下の申請書に記入してください。",
          "point-1" : "「登録フォームは3つのステップで構成されており、所要時間は約5〜10分です」、",
          "point-2": "あなたの組織はすでにTelekom Data Intelligence Hubに登録されているため、フォームに利用可能なデータを事前に入力して、完了プロセスをできるだけスムーズかつ簡単にします。",
          "point-3": "この登録プロセスをよりよく理解するために、いつでもナレッジベースでヘルプガイドを見ることができます。詳細については、{hereLink}をクリックしてください。",
          "here": "ここ",
          "letStarted": "さっそく始めましょう"
        }
      },
      "title": "Catena-Xエコシステムへの登録",
      "description": "次の3つのステップで要求されたすべての情報を入力して、Catena-Xに登録してください。",
      "description2": "Catena-X Automotive Network Portalのすべての機能に積極的に参加して使用するために、以下のタスクを完了して会社のオンボーディングを終了してください。",
      "note": "先に進む前に必要な情報をすべて入力してください。詳細については、{help}セクションをご覧ください。",
      "companyDataStepTitle": "会社データ",
      "companyRoleStepTitle": "会社の役割",
      "verifyAndSubmitStepTitle": "確認して送信",
      "companyData": {
        "title": "会社のデータを追加",
        "description": "以下に法人の会社データを追加してください。必須フィールドは(*)で強調表示され、フォームにはオンボーディング中にすでに提供された情報が事前に入力されています。",
        "organizationName": "組織名",
        "organizationNameTooltip": "登録された組織名",
        "enterYourData": "データを入力してください",
        "bpn": "ビジネスパートナー番号",
        "bpnTooltip": "ビジネスパートナー番号 (BPN) は、Catena-X エコシステムの下で各ビジネスパートナーに割り当てられる一意の識別子です。",
        "legalEntityName": "法人名",
        "transliteratedName": "ローマ字表記 (ラテン文字)",
        "registeredName": "登録名",
        "orgAddress": "組織の住所",
        "streetName": "通りの名前",
        "houseNumber": "家屋番号",
        "postCode": "郵便番号",
        "city": "都市",
        "countryCode": "国コード",
        "region": "地域",
        "companyIdentifier": "会社識別子",
        "identifierType": "識別子の種類",
        "identifierNumber": "識別子番号",
        "contactInfo": "連絡先情報",
        "emailAddress": "メールアドレス",
        "userRole": "ユーザーロール",
        "CRN": {
          "label": "商業登記番号",
          "helpText": "例: HRB 55933",
          "tooltipText": "商業登記番号(CRN)は、合法的な商業登録のために企業に割り当てられる一意の識別子です。これは、信頼できるデータソースに対する企業の登録および金融取引識別子の信頼性を検証および検証するために使用されます。」"
        },
        "vatId": {
          "label": "VAT番号",
          "helpText": "例: DE 118 645 675",
          "tooltipText": "VAT番号(付加価値税識別番号)は、税務目的でビジネスに割り当てられた一意の識別子です。"
        }
      },
      "companyRole": {
        "title": "あなたの会社の役割",
        "description": "Catena-Xネットワークで行動/参加したい会社の役割を1つまたは複数選択してください。会社ロールは、後でいつでも更新/変更できます。選択したロールに応じて、提供されるポータル サービスが異なる場合があります。",
        "activeParticipanyNote": "T-Systems Connect & Integrateを使用して、Catena-Xへの参加を調整し、最適化して、Catena-Xへの簡単で自動化された接続を実現します。Cofinity App マーケットプレイスから Connect & Integrate を注文して、主要な Catena-X のユースケースを入手し、すぐにデータ交換を開始してください。月額49ユーロから始まり、すべての業界規模で利用できます。",
        "agreeTermsCheckbox": "はい、選択したロールの{link}に同意します",
        "activeParticipantNote": {
          "para1": "Catena-Xへの簡単で自動化された接続のために、{link}を使用してCatena-Xへの参加を調整し、最適化してください。",
          "tSystemsConnectAndIntegrate": "T-Systems Connect & Integrate",
          "para2": "CofinityアプリマーケットプレイスからConnect&Integrateを注文して、主要なCatena-Xのユースケースに対応し、すぐにデータ交換を開始してください!",
          "para3": "{price}/月から始まり、あらゆる業種でご利用いただけます。"
        },
        "appProviderNote": {
          "para1": "{link}は、当社の公式Catena-X Sandbox環境内でビジネスアプリケーションを開発、管理、認証することを可能にします。",
          "para2": "今すぐ注文ビルド&オペレーションを行い、お客様がイノベーションに集中している間、お客様のデータスペースインフラストラクチャを当社にお任せください!",
          "para1PlaceholderLink": "T-Systems' ビルド&オペレーション",
          "optionalInformation": "オプション情報"
        }
      },
      "verifyAndSubmit": {
        "title": "登録データを確認してください",
        "description": "登録を提出する前に、会社の登録データを確認してください。すべての情報が正しく入力されていることを確認してください。確認が完了したらすぐに、下の[送信]ボタンをクリックして、承認のために登録を送信してください。",
        "companyData": "会社データ",
        "activeRole": "アクティブなロール",
        "consentText": "私は、T-Systems International GmbHが私の登録リクエストをCofinity-X GmbHに提出し、オンボーディング手続きおよび関連する目的のために関連する個人データを処理することに同意します。私は、私のデータが、一般データ保護規則(GDPR)を含むがこれに限定されない、適用されるデータ保護法および規制に従って処理されることを認めます。私は、私の個人データがこれらの目的を達成するために必要な期間のみ保存されることを理解しています。私は、この同意がCofinity-X GmbHへの登録とオンボーディングに必要であり、将来に向けていつでも同意を撤回できることを認識しています。」"
      },
      "actions": {
        "back": "戻る",
        "next": "次へ",
        "submit": "送信"
      },
      "validation": {
        "DE_COMMERCIAL_REG_NUMBER": "有効な番号を入力してください。ヒント:英数字とハイフン、スペースは正確な9桁です。",
        "DE_VAT_ID": "有効な番号を入力してください。ヒント:DEで始まり、その後に9桁の数字が続きます。",
        "Worldwide_COMMERCIAL_REG_NUMBER": "有効な番号を入力してください。ヒント:英数字と6〜21桁のハイフン。",
        "Worldwide_VAT_ID": "有効な番号を入力してください。ヒント:英数字とハイフン、スペースは8〜15桁です。",
        "invalid_bpn": "BPN番号が無効です。BPN番号は、BPNLで始まり、その後に12文字の英数字が続く必要があります。"
      },
      "error": {
        "title": "検証エラー",
        "para": "あなたの組織はすでにCofinity-Xネットワーク内に存在しているか、現在対処中の技術的な問題があります。私たちがあなたをさらに助けることができるように、あなたの経験についてもっと教えてください。",
        "buttonText": "お問い合わせ"
      },
      "success": {
        "title": "リクエストを送信していただきありがとうございます",
        "para": "あなたの詳細はCofinity-Xに送信されました。次のステップに関する情報をメールでお届けします",
        "buttonText": "ホームページに移動"
      }
    },
    "demoOrg": {
      "title": "デモ組織",
      "tooltip": "これはデモ/評価組織です。",
      "tooltip1": "一部の機能が制限される場合があります。"
    }
  }